import React from "react";
import { PDFDocument } from "pdf-lib";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import { Button, IconButton } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import moment from 'moment';
import Loader from "react-loader-spinner";
import TextField from '@material-ui/core/TextField';
import { useState, useEffect } from "react";


import {
  getRespondentFormData,
  putCommunityProperty,
  putSeparateProperty,
  putChildCustodyRights,
  putDomesticViolence,
  putChildCustodyCase,
  putRespondantFilingOptions,
  putMarriedBefore,
  putRespondantFiledPetition,
  putDenyingDissolvingMarriage,
  getAddForms,
  putAddSppousalSupport,
  putAddCustody,
  putFormerLastName,
  putChildResidence,
  putChildAge,
  getCustodyTypes,
  getCustodySubtypes,
  postDPDetails,
  getStates,
  getFillingOption,
  getDivorceLS,
  getNullity,
  getDivorce,
  putDates,
  putUpdateData,
  isResidence
} from "./responsePacket.actions";

import {
  getFormData as getProfileFormData
} from "../forms/profileInformation/profileInformation.actions";
import { getAllData as childGetAllData } from "../forms/childInformation/ChildInformationAction";



import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Collapse,
  CustomInput,
  Card,
  ModalBody,
  Modal
} from "reactstrap";
import { isEmpty, isNumber, remove, filter, isUndefined, size, isNaN, get, has, forEach } from "lodash";
import { parseDate, serverApi } from "../../../global/globalFunctions";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

//COMPONENT

function VerticalLinearStepper(props) {


  const petitionerDetails = props.petitioner;
  const respondentDetails = props.respondent;
  const courtDetails = props.court;

  const petState = !isUndefined(petitionerDetails) && filter(props.states, state => state.state_id == petitionerDetails.state);
  const resState = !isUndefined(respondentDetails) && filter(props.states, state => state.state_id == respondentDetails.state);
  useEffect(() => {
    props.getProfileFormData({ divorce_id: window.localStorage.getItem("divorce_id") });
    props.getRespondentFormData();
    props.getStates();
    props.getFillingOption();
    props.getDivorceLS();
    props.getNullity();
    window.localStorage.getItem("divorce_id") === undefined &&
      props.getDivorce({ userId: window.localStorage.getItem("user_id") });
    props.childGetAllData({ divorce_id: window.localStorage.getItem("divorce_id") });
    arrayCBOne();
  }, []);

  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  function getSteps() {
    return [
      "Filed Petition",
      "Domestic Partnership",
      "Contend that you were never married",
      "Requesting to dissolve your marriage",
      "Residence",
      "Please select",
      "Please provide Date of Marriage & Sepration",
      "Do you have children",
      "Legal Custody, Physical Custody & Child visitation",
      "Custody of your child",
      "Domestic violence",
      "Custody rights to your children",
      "Spousal Support",
      "Separate Property",
      "Community property",
      "Former last name",
    ];
  }
  async function myFunctionFL105A() {
    const existingPdfBytes = await fetch(`${serverApi}/FL-105(a)`, {
      headers: {
        Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
      },
    }).then((res) => res.arrayBuffer());

    var bytes = new Uint8Array(existingPdfBytes);;
    const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
    const form = pdfDoc.getForm();

    !isUndefined(courtDetails) && form.getField("caseNumber").setText(courtDetails.caseNumber.toString());


    let childLive3 = get(props.addressConfidential, 'yes.childDetails[2].child_live_cond');
    let childAddress3 = get(props.addressConfidential, 'yes.childDetails[2].confidential');

    let ResidenceChildTwo = !isEmpty(props.addressConfidential.yes.sameResidence) && size(props.addressConfidential.yes.sameResidence.find(x => x == "2"));

    var TChildF = get(props.underAge18Child, 'yes.childInfo[2].first_name', "");
    var TChildS = get(props.underAge18Child, 'yes.childInfo[2].last_name', "");

    var genderThird = get(props.underAge18Child, 'yes.childInfo[2].sex')

    has(props.underAge18Child, 'yes.childInfo[2].first_name') && form.getField("childNum").setText("03");

    !isUndefined(TChildF) && form.getField("childName").setText(`${TChildF}` + ` ` + `${TChildS}`);
    has(props.underAge18Child, 'yes.childInfo[2].place_birth') && form.getField("PoB").setText(get(props.underAge18Child, 'yes.childInfo[2].place_birth', ""));
    has(props.underAge18Child, 'yes.childInfo[2].dob') && get(props.underAge18Child, 'yes.childInfo[2].dob') == "1947-01-01" ? form.getField("DoB").setText("") : form.getField("DoB").setText(parseDate(get(props.underAge18Child, 'yes.childInfo[2].dob', "")));
    !isUndefined(genderThird) && genderThird == 0 ? form.getField("sex").setText("M") : genderThird == 1 ? form.getField("sex").setText("F") : genderThird == 2 ? form.getField("sex").setText("Other") : form.getField("sex").setText("");

    !isUndefined(ResidenceChildTwo) && ResidenceChildTwo == '1' ? form.getField("ch_r").check() : form.getField("ch_r").uncheck();

    if (ResidenceChildTwo == "0") {

      let childLiveWithTwo = has(props.addressConfidential, 'yes.childDetails[2].child_live') && (get(props.addressConfidential, 'yes.childDetails[2].child_live', ""));
      let childAddressTwo = has(props.addressConfidential, 'yes.childDetails[2].address_child') && (get(props.addressConfidential, 'yes.childDetails[2].address_child', ""))
      !isEmpty(childLiveWithTwo) && form.getField("childLive0").setText(`${childLiveWithTwo}` + `, ` + `${childAddressTwo}`);


      has(props.addressConfidential, 'yes.childDetails[2].datefrom') && (get(props.addressConfidential, 'yes.childDetails[2].date_from') == '1947-01-01') ? form.getField("residence").setText("") : form.getField("residence").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[2].datefrom', "")));
      has(props.addressConfidential, 'yes.childDetails[2].childrelation') && form.getField("relation0").setText(get(props.addressConfidential, 'yes.childDetails[2].childrelation', ""));
      has(props.addressConfidential, 'yes.childDetails[2].address_child') && form.getField("presentAddress").setText(get(props.addressConfidential, 'yes.childDetails[2].address_child', ""));
      !isUndefined(childLive3) && childLive3 == '1' ? form.getField("ChildLiveConf").check() : form.getField("ChildLiveConf").uncheck();
      !isUndefined(childAddress3) && childAddress3 == '1' ? form.getField("confidentials").check() : form.getField("confidentials").uncheck();


      has(props.addressConfidential, 'yes.childDetails[2].childRes[0].date_from') && (get(props.addressConfidential, 'yes.childDetails[2].childRes[0].date_from') == '1947-01-01') ? form.getField("from0").setText("") : form.getField("from0").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[2].childRes[0].date_from', "")));
      has(props.addressConfidential, 'yes.childDetails[2].childRes[0].date_to') && (get(props.addressConfidential, 'yes.childDetails[2].childRes[0].date_to') == '1947-01-01') ? form.getField("to0").setText("") : form.getField("to0").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[2].childRes[0].date_to', "")));
      has(props.addressConfidential, 'yes.childDetails[2].childRes[0].child_live_with') && form.getField("childLive1").setText(get(props.addressConfidential, 'yes.childDetails[2].childRes[0].child_live_with', "").concat(`, ` + get(props.addressConfidential, 'yes.childDetails[2].childRes[0].child_address', "")));
      has(props.addressConfidential, 'yes.childDetails[2].childRes[0].relationship') && form.getField("relation1").setText(get(props.addressConfidential, 'yes.childDetails[2].childRes[0].relationship', ""));
      has(props.addressConfidential, 'yes.childDetails[2].childRes[0].child_address') && form.getField("state0").setText(get(props.addressConfidential, 'yes.childDetails[2].childRes[0].child_address', ""));


      has(props.addressConfidential, 'yes.childDetails[2].childRes[1].date_from') && (get(props.addressConfidential, 'yes.childDetails[2].childRes[1].date_from') == '1947-01-01') ? form.getField("from1").setText("") : form.getField("from1").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[2].childRes[1].date_from', "")));
      has(props.addressConfidential, 'yes.childDetails[2].childRes[1].date_to') && (get(props.addressConfidential, 'yes.childDetails[2].childRes[1].date_to') == '1947-01-01') ? form.getField("to1").setText("") : form.getField("to1").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[2].childRes[1].date_to', "")));
      has(props.addressConfidential, 'yes.childDetails[2].childRes[1].child_live_with') && form.getField("childLive2").setText(get(props.addressConfidential, 'yes.childDetails[2].childRes[1].child_live_with', "").concat(`, ` + get(props.addressConfidential, 'yes.childDetails[2].childRes[1].child_address', "")));
      has(props.addressConfidential, 'yes.childDetails[2].childRes[1].relationship') && form.getField("relation2").setText(get(props.addressConfidential, 'yes.childDetails[2].childRes[1].relationship', ""));
      has(props.addressConfidential, 'yes.childDetails[2].childRes[1].child_address') && form.getField("state1").setText(get(props.addressConfidential, 'yes.childDetails[2].childRes[1].child_address', ""));


      has(props.addressConfidential, 'yes.childDetails[2].childRes[2].date_from') && (get(props.addressConfidential, 'yes.childDetails[2].childRes[2].date_from') == '1947-01-01') ? form.getField("from2").setText("") : form.getField("from2").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[2].childRes[2].date_from', "")));
      has(props.addressConfidential, 'yes.childDetails[2].childRes[2].date_to') && (get(props.addressConfidential, 'yes.childDetails[2].childRes[2].date_to') == '1947-01-01') ? form.getField("to2").setText("") : form.getField("to2").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[2].childRes[2].date_to', "")));
      has(props.addressConfidential, 'yes.childDetails[2].childRes[2].child_live_with') && form.getField("childLive3").setText(get(props.addressConfidential, 'yes.childDetails[2].childRes[2].child_live_with', "").concat(`, ` + get(props.addressConfidential, 'yes.childDetails[2].childRes[2].child_address', "")));
      has(props.addressConfidential, 'yes.childDetails[2].childRes[2].relationship') && form.getField("relation3").setText(get(props.addressConfidential, 'yes.childDetails[2].childRes[2].relationship', ""));
      has(props.addressConfidential, 'yes.childDetails[2].childRes[2].child_address') && form.getField("state2").setText(get(props.addressConfidential, 'yes.childDetails[2].childRes[2].child_address', ""));
    }



    let childLive4 = get(props.addressConfidential, 'yes.childDetails[3].child_live_cond');
    let childAddress4 = get(props.addressConfidential, 'yes.childDetails[3].confidential');

    let ResidenceChildThree = !isEmpty(props.addressConfidential.yes.sameResidence) && size(props.addressConfidential.yes.sameResidence.find(x => x == "3"));

    var FChildF = get(props.underAge18Child, 'yes.childInfo[3].first_name', "");
    var FChildS = get(props.underAge18Child, 'yes.childInfo[3].last_name', "");

    var genderFourth = get(props.underAge18Child, 'yes.childInfo[3].sex')

    has(props.underAge18Child, 'yes.childInfo[3].first_name') && form.getField("SchildNum").setText("04");

    !isUndefined(FChildF) && form.getField("SchildName").setText(`${FChildF}` + ` ` + `${FChildS}`);
    has(props.underAge18Child, 'yes.childInfo[3].place_birth') && form.getField("SPoB").setText(get(props.underAge18Child, 'yes.childInfo[3].place_birth', ""));
    has(props.underAge18Child, 'yes.childInfo[3].dob') && get(props.underAge18Child, 'yes.childInfo[3].dob') == "1947-01-01" ? form.getField("SDoB").setText("") : form.getField("SDoB").setText(parseDate(get(props.underAge18Child, 'yes.childInfo[3].dob', "")));
    !isUndefined(genderFourth) && genderFourth == 0 ? form.getField("Ssex").setText("M") : genderFourth == 1 ? form.getField("Ssex").setText("F") : genderFourth == 2 ? form.getField("Ssex").setText("Other") : form.getField("Ssex").setText("");

    !isUndefined(ResidenceChildThree) && ResidenceChildThree == '1' ? form.getField("Sch_r").check() : form.getField("Sch_r").uncheck();

    if (ResidenceChildThree == "0") {

      has(props.addressConfidential, 'yes.childDetails[3].datefrom') && (get(props.addressConfidential, 'yes.childDetails[3].date_from') == '1947-01-01') ? form.getField("Sresidence").setText("") : form.getField("Sresidence").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[3].datefrom', "")));
      has(props.addressConfidential, 'yes.childDetails[3].child_live') && form.getField("SchildLive0").setText(get(props.addressConfidential, 'yes.childDetails[3].child_live', "").concat(`, ` + get(props.addressConfidential, 'yes.childDetails[3].address_child', "")));
      has(props.addressConfidential, 'yes.childDetails[3].childrelation') && form.getField("Srelation0").setText(get(props.addressConfidential, 'yes.childDetails[3].childrelation', ""));
      has(props.addressConfidential, 'yes.childDetails[3].address_child') && form.getField("SpresentAddress").setText(get(props.addressConfidential, 'yes.childDetails[3].address_child', ""));
      !isUndefined(childLive4) && childLive4 == '1' ? form.getField("SChildLiveConf").check() : form.getField("SChildLiveConf").uncheck();
      !isUndefined(childAddress4) && childAddress4 == '1' ? form.getField("Sconfidentials").check() : form.getField("Sconfidentials").uncheck();


      has(props.addressConfidential, 'yes.childDetails[3].childRes[0].date_from') && (get(props.addressConfidential, 'yes.childDetails[3].childRes[0].date_from') == '1947-01-01') ? form.getField("Sfrom0").setText("") : form.getField("Sfrom0").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[3].childRes[0].date_from', "")));
      has(props.addressConfidential, 'yes.childDetails[3].childRes[0].date_to') && (get(props.addressConfidential, 'yes.childDetails[3].childRes[0].date_to') == '1947-01-01') ? form.getField("Sto0").setText("") : form.getField("Sto0").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[3].childRes[0].date_to', "")));
      has(props.addressConfidential, 'yes.childDetails[3].childRes[0].child_live_with') && form.getField("SchildLive1").setText(get(props.addressConfidential, 'yes.childDetails[3].childRes[0].child_live_with', "").concat(`, ` + get(props.addressConfidential, 'yes.childDetails[3].childRes[0].child_address', "")));
      has(props.addressConfidential, 'yes.childDetails[3].childRes[0].relationship') && form.getField("Srelation1").setText(get(props.addressConfidential, 'yes.childDetails[3].childRes[0].relationship', ""));
      has(props.addressConfidential, 'yes.childDetails[3].childRes[0].child_address') && form.getField("Sstate0").setText(get(props.addressConfidential, 'yes.childDetails[3].childRes[0].child_address', ""));


      has(props.addressConfidential, 'yes.childDetails[3].childRes[1].date_from') && (get(props.addressConfidential, 'yes.childDetails[3].childRes[1].date_from') == '1947-01-01') ? form.getField("Sfrom1").setText("") : form.getField("Sfrom1").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[3].childRes[1].date_from', "")));
      has(props.addressConfidential, 'yes.childDetails[3].childRes[1].date_to') && (get(props.addressConfidential, 'yes.childDetails[3].childRes[1].date_to') == '1947-01-01') ? form.getField("Sto1").setText("") : form.getField("Sto1").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[3].childRes[1].date_to', "")));
      has(props.addressConfidential, 'yes.childDetails[3].childRes[1].child_live_with') && form.getField("SchildLive2").setText(get(props.addressConfidential, 'yes.childDetails[3].childRes[1].child_live_with', "").concat(`, ` + get(props.addressConfidential, 'yes.childDetails[3].childRes[1].child_address', "")));
      has(props.addressConfidential, 'yes.childDetails[3].childRes[1].relationship') && form.getField("Srelation2").setText(get(props.addressConfidential, 'yes.childDetails[3].childRes[1].relationship', ""));
      has(props.addressConfidential, 'yes.childDetails[3].childRes[1].child_address') && form.getField("Sstate1").setText(get(props.addressConfidential, 'yes.childDetails[3].childRes[1].child_address', ""));


      has(props.addressConfidential, 'yes.childDetails[3].childRes[2].date_from') && (get(props.addressConfidential, 'yes.childDetails[3].childRes[2].date_from') == '1947-01-01') ? form.getField("Sfrom2").setText("") : form.getField("Sfrom2").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[3].childRes[2].date_from', "")));
      has(props.addressConfidential, 'yes.childDetails[3].childRes[2].date_to') && (get(props.addressConfidential, 'yes.childDetails[3].childRes[2].date_to') == '1947-01-01') ? form.getField("Sto2").setText("") : form.getField("Sto2").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[3].childRes[2].date_to', "")));
      has(props.addressConfidential, 'yes.childDetails[3].childRes[2].child_live_with') && form.getField("SchildLive3").setText(get(props.addressConfidential, 'yes.childDetails[3].childRes[2].child_live_with', "").concat(`, ` + get(props.addressConfidential, 'yes.childDetails[3].childRes[2].child_address', "")));
      has(props.addressConfidential, 'yes.childDetails[3].childRes[2].relationship') && form.getField("Srelation3").setText(get(props.addressConfidential, 'yes.childDetails[3].childRes[2].relationship', ""));
      has(props.addressConfidential, 'yes.childDetails[3].childRes[2].child_address') && form.getField("Sstate2").setText(get(props.addressConfidential, 'yes.childDetails[3].childRes[2].child_address', ""));

    }



    // form.flatten();
    const pdfBytes = await pdfDoc.save();
    const pdfDataUrl = URL.createObjectURL(
      new Blob([pdfBytes], { type: "application/pdf" })
    );
    window.open(pdfDataUrl, "_blank");
  }



  // async function myFunctionFL105() {
  //   const existingPdfBytes = await fetch(`${serverApi}/FL-105`, {
  //     headers: {
  //       Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
  //     },
  //   }).then((res) => res.arrayBuffer());

  //   var bytes = new Uint8Array(existingPdfBytes);
  //   const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
  //   const form = pdfDoc.getForm();

  //   !isUndefined(respondentDetails) && form.getField("name").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
  //   !isUndefined(respondentDetails) && form.getField("state").setText(`${respondentDetails.streetAddress}`);
  //   !isUndefined(respondentDetails) && form.getField("barNumber").setText(`${respondentDetails.city}` + `,` + `${petState[0].state_name}` + ` ` + `${respondentDetails.zip}`);
  //   !isUndefined(respondentDetails) && form.getField("telephone").setText(respondentDetails.telephone);
  //   !isUndefined(respondentDetails) && form.getField("email").setText(respondentDetails.email);
  //   !isUndefined(respondentDetails) && form.getField("Print").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);


  //   !isUndefined(courtDetails) && form.getField("address").setText(courtDetails.courtStreetAddress);
  //   !isUndefined(courtDetails) && form.getField("mailing").setText(courtDetails.courtMailingAddress);
  //   !isUndefined(courtDetails) && form.getField("city").setText(`${courtDetails.city}` + ` ` + `${courtDetails.zip}`);
  //   !isUndefined(courtDetails) && form.getField("branch").setText(courtDetails.branchName);
  //   !isUndefined(courtDetails) && form.getField("superior").setText(courtDetails.county);


  //   !isUndefined(petitionerDetails) && form.getField("petitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
  //   !isUndefined(respondentDetails) && form.getField("respondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
  //   !isUndefined(courtDetails) && form.getField("caseNumber").setText(courtDetails.caseNumber.toString());

  //   !isUndefined(courtDetails) && form.getField("case").setText(courtDetails.caseNumber.toString());


  //   !isUndefined(props.addressConfidential.no.addressConfidentialStatus) && props.addressConfidential.no.addressConfidentialStatus == "1" ? form.getCheckBox("ch_p").check() : form.getCheckBox("ch_p").uncheck();

  //   let childLive1 = get(props.addressConfidential, 'yes.childDetails[0].child_live_cond');
  //   let childAddress1 = get(props.addressConfidential, 'yes.childDetails[0].confidential');

  //   var Number = props.underAge18Child.yes.childInfo.length;

  //   !isUndefined(Number) && form.getField("specify").setText(Number.toString());


  //   var FChildF = get(props.underAge18Child, 'yes.childInfo[0].first_name', "");
  //   var FChildS = get(props.underAge18Child, 'yes.childInfo[0].last_name', "");

  //   var gender = get(props.underAge18Child, 'yes.childInfo[0].sex')

  //   !isUndefined(FChildF) && form.getField("childName").setText(`${FChildF}` + ` ` + `${FChildS}`);
  //   has(props.underAge18Child, 'yes.childInfo[0].place_birth') && form.getField("PoB").setText(get(props.underAge18Child, 'yes.childInfo[0].place_birth', ""));
  //   has(props.underAge18Child, 'yes.childInfo[0].dob') && get(props.underAge18Child, 'yes.childInfo[0].dob') == "1947-01-01" ? form.getField("DoB").setText("") : form.getField("DoB").setText(parseDate(parseDate(get(props.underAge18Child, 'yes.childInfo[0].dob', ""))));
  //   !isUndefined(gender) && gender == 0 ? form.getField("sex").setText("M") : gender == 1 ? form.getField("sex").setText("F") : gender == 2 ? form.getField("sex").setText("Other") : form.getField("sex").setText("");


  //   let childLiveWith = has(props.addressConfidential, 'yes.childDetails[0].child_live') && (get(props.addressConfidential, 'yes.childDetails[0].child_live', ""));
  //   let childAddress = has(props.addressConfidential, 'yes.childDetails[0].address_child') && (get(props.addressConfidential, 'yes.childDetails[0].address_child', ""))
  //   !isEmpty(childLiveWith) && form.getField("childLive0").setText(`${childLiveWith}` + `, ` + `${childAddress}`);


  //   has(props.addressConfidential, 'yes.childDetails[0].datefrom') && (get(props.addressConfidential, 'yes.childDetails[0].date_from') == '1947-01-01') ? form.getField("residence").setText("") : form.getField("residence").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[0].datefrom', "")));
  //   has(props.addressConfidential, 'yes.childDetails[0].childrelation') && form.getField("relation0").setText(get(props.addressConfidential, 'yes.childDetails[0].childrelation', ""));
  //   has(props.addressConfidential, 'yes.childDetails[0].address_child') && form.getField("presentAddress").setText(get(props.addressConfidential, 'yes.childDetails[0].address_child', ""));
  //   !isUndefined(childLive1) && childLive1 == '1' ? form.getField("ChildLiveConf").check() : form.getField("ChildLiveConf").uncheck();
  //   !isUndefined(childAddress1) && childAddress1 == '1' ? form.getField("confidentials").check() : form.getField("confidentials").uncheck();


  //   has(props.addressConfidential, 'yes.childDetails[0].childRes[0].date_from') && (get(props.addressConfidential, 'yes.childDetails[0].childRes[0].date_from') == '1947-01-01') ? form.getField("from0").setText("") : form.getField("from0").setText(parseDate(parseDate(get(props.addressConfidential, 'yes.childDetails[0].childRes[0].date_from', ""))));
  //   has(props.addressConfidential, 'yes.childDetails[0].childRes[0].date_to') && (get(props.addressConfidential, 'yes.childDetails[0].childRes[0].date_to') == '1947-01-01') ? form.getField("to0").setText("") : form.getField("to0").setText(parseDate(parseDate(get(props.addressConfidential, 'yes.childDetails[0].childRes[0].date_to', ""))));
  //   has(props.addressConfidential, 'yes.childDetails[0].childRes[0].child_live_with') && form.getField("childLive1").setText(get(props.addressConfidential, 'yes.childDetails[0].childRes[0].child_live_with', "").concat(`, ` + get(props.addressConfidential, 'yes.childDetails[0].childRes[0].child_address', "")));
  //   has(props.addressConfidential, 'yes.childDetails[0].childRes[0].relationship') && form.getField("relation1").setText(get(props.addressConfidential, 'yes.childDetails[0].childRes[0].relationship', ""));
  //   has(props.addressConfidential, 'yes.childDetails[0].childRes[0].child_address') && form.getField("state0").setText(get(props.addressConfidential, 'yes.childDetails[0].childRes[0].child_address', ""));


  //   has(props.addressConfidential, 'yes.childDetails[0].childRes[1].date_from') && (get(props.addressConfidential, 'yes.childDetails[0].childRes[1].date_from') == '1947-01-01') ? form.getField("from1").setText("") : form.getField("from1").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[0].childRes[1].date_from', "")));
  //   has(props.addressConfidential, 'yes.childDetails[0].childRes[1].date_to') && (get(props.addressConfidential, 'yes.childDetails[0].childRes[1].date_to') == '1947-01-01') ? form.getField("to1").setText("") : form.getField("to1").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[0].childRes[1].date_to', "")));
  //   has(props.addressConfidential, 'yes.childDetails[0].childRes[1].child_live_with') && form.getField("childLive2").setText(get(props.addressConfidential, 'yes.childDetails[1].childRes[0].child_live_with', "").concat(`, ` + get(props.addressConfidential, 'yes.childDetails[0].childRes[1].child_address', "")));
  //   has(props.addressConfidential, 'yes.childDetails[0].childRes[1].relationship') && form.getField("relation2").setText(get(props.addressConfidential, 'yes.childDetails[0].childRes[1].relationship', ""));
  //   has(props.addressConfidential, 'yes.childDetails[0].childRes[1].child_address') && form.getField("state1").setText(get(props.addressConfidential, 'yes.childDetails[0].childRes[1].child_address', ""));


  //   has(props.addressConfidential, 'yes.childDetails[0].childRes[2].date_from') && (get(props.addressConfidential, 'yes.childDetails[0].childRes[1].date_from') == '1947-01-01') ? form.getField("from2").setText("") : form.getField("from2").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[0].childRes[2].date_from', "")));
  //   has(props.addressConfidential, 'yes.childDetails[0].childRes[2].date_to') && (get(props.addressConfidential, 'yes.childDetails[0].childRes[2].date_to') == '1947-01-01') ? form.getField("to2").setText("") : form.getField("to2").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[0].childRes[2].date_to', "")));
  //   has(props.addressConfidential, 'yes.childDetails[0].childRes[2].child_live_with') && form.getField("childLive3").setText(get(props.addressConfidential, 'yes.childDetails[2].childRes[0].child_live_with', "").concat(`, ` + get(props.addressConfidential, 'yes.childDetails[2].childRes[0].child_address', "")));
  //   has(props.addressConfidential, 'yes.childDetails[0].childRes[2].relationship') && form.getField("relation3").setText(get(props.addressConfidential, 'yes.childDetails[2].childRes[0].relationship', ""));
  //   has(props.addressConfidential, 'yes.childDetails[0].childRes[2].child_address') && form.getField("state2").setText(get(props.addressConfidential, 'yes.childDetails[2].childRes[0].child_address', ""));


  //   !isUndefined(props.custodyRights.custodyRightsStatus) && props.custodyRights.custodyRightsStatus == '1' ? form.getField("ch_yes").check() : form.getField("ch_no").check();
  //   !isUndefined(props.childCustodyCase.childCustodyCaseStatus) && props.childCustodyCase.childCustodyCaseStatus == '1' ? form.getField("yes").check() : form.getField("no").check();
  //   !isUndefined(Number) && Number > 2 ? form.getField("children").check() : form.getField("children").uncheck();
  //   !isUndefined(props.addressConfidential.no.addressConfidentialStatus) && props.addressConfidential.no.addressConfidentialStatus == "1" ? form.getField("ch_p").check() : form.getField("ch_p").uncheck();
  //   !isUndefined(props.domesticVoilence.domesticVoilenceStatus) && props.domesticVoilence.domesticVoilenceStatus == "1" ? form.getField("more").check() : form.getField("more").uncheck();






  //   let childLive2 = get(props.addressConfidential, 'yes.childDetails[1].child_live_cond');
  //   let childAddress2 = get(props.addressConfidential, 'yes.childDetails[1].confidential');

  //   let ResidenceChildOne = !isEmpty(props.addressConfidential.yes.sameResidence) && size(props.addressConfidential.yes.sameResidence.find(x => x == "1"));

  //   var SChildF = get(props.underAge18Child, 'yes.childInfo[1].first_name', "");
  //   var SChildS = get(props.underAge18Child, 'yes.childInfo[1].last_name', "");

  //   var genderSecond = get(props.underAge18Child, 'yes.childInfo[1].sex')

  //   !isUndefined(SChildF) && form.getField("SchildName").setText(`${SChildF}` + ` ` + `${SChildS}`);
  //   has(props.underAge18Child, 'yes.childInfo[1].place_birth') && form.getField("SPoB").setText(get(props.underAge18Child, 'yes.childInfo[1].place_birth', ""));
  //   has(props.underAge18Child, 'yes.childInfo[1].dob') && get(props.underAge18Child, 'yes.childInfo[1].dob') == "1947-01-01" ? form.getField("SDoB").setText("") : form.getField("SDoB").setText(parseDate(get(props.underAge18Child, 'yes.childInfo[1].dob', "")));
  //   !isUndefined(genderSecond) && genderSecond == 0 ? form.getField("Ssex").setText("M") : genderSecond == 1 ? form.getField("Ssex").setText("F") : genderSecond == 2 ? form.getField("Ssex").setText("Other") : form.getField("Ssex").setText("");

  //   !isUndefined(ResidenceChildOne) && ResidenceChildOne == '1' ? form.getField("ch_r").check() : form.getField("ch_r").uncheck();

  //   if (ResidenceChildOne == "0") {

  //     has(props.addressConfidential, 'yes.childDetails[1].datefrom') && (get(props.addressConfidential, 'yes.childDetails[1].date_from') == '1947-01-01') ? form.getField("Sresidence").setText("") : form.getField("Sresidence").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[1].datefrom', "")));
  //     has(props.addressConfidential, 'yes.childDetails[1].child_live') && form.getField("SchildLive0").setText(get(props.addressConfidential, 'yes.childDetails[1].child_live', "").concat(`, ` + get(props.addressConfidential, 'yes.childDetails[1].address_child', "")));
  //     has(props.addressConfidential, 'yes.childDetails[1].childrelation') && form.getField("Srelation0").setText(get(props.addressConfidential, 'yes.childDetails[1].childrelation', ""));
  //     has(props.addressConfidential, 'yes.childDetails[1].address_child') && form.getField("SpresentAddress").setText(get(props.addressConfidential, 'yes.childDetails[1].address_child', ""));
  //     !isUndefined(childLive2) && childLive2 == '1' ? form.getField("SChildLiveConf").check() : form.getField("SChildLiveConf").uncheck();
  //     !isUndefined(childAddress2) && childAddress2 == '1' ? form.getField("Sconfidentials").check() : form.getField("Sconfidentials").uncheck();



  //     has(props.addressConfidential, 'yes.childDetails[1].childRes[0].date_from') && (get(props.addressConfidential, 'yes.childDetails[1].childRes[0].date_from') == '1947-01-01') ? form.getField("Sfrom0").setText("") : form.getField("Sfrom0").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[1].childRes[0].date_from', "")));
  //     has(props.addressConfidential, 'yes.childDetails[1].childRes[0].date_to') && (get(props.addressConfidential, 'yes.childDetails[1].childRes[0].date_to') == '1947-01-01') ? form.getField("Sto0").setText("") : form.getField("Sto0").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[1].childRes[0].date_to', "")));
  //     has(props.addressConfidential, 'yes.childDetails[1].childRes[0].child_live_with') && form.getField("SchildLive1").setText(get(props.addressConfidential, 'yes.childDetails[1].childRes[0].child_live_with', "").concat(`, ` + get(props.addressConfidential, 'yes.childDetails[1].childRes[0].child_address', "")));
  //     has(props.addressConfidential, 'yes.childDetails[1].childRes[0].relationship') && form.getField("Srelation1").setText(get(props.addressConfidential, 'yes.childDetails[1].childRes[0].relationship', ""));
  //     has(props.addressConfidential, 'yes.childDetails[1].childRes[0].child_address') && form.getField("Sstate0").setText(get(props.addressConfidential, 'yes.childDetails[1].childRes[0].child_address', ""));



  //     has(props.addressConfidential, 'yes.childDetails[1].childRes[1].date_from') && (get(props.addressConfidential, 'yes.childDetails[1].childRes[1].date_from') == '1947-01-01') ? form.getField("Sfrom1").setText("") : form.getField("Sfrom1").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[1].childRes[1].date_from', "")));
  //     has(props.addressConfidential, 'yes.childDetails[1].childRes[1].date_to') && (get(props.addressConfidential, 'yes.childDetails[1].childRes[1].date_to') == '1947-01-01') ? form.getField("Sto1").setText("") : form.getField("Sto1").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[1].childRes[1].date_to', "")));
  //     has(props.addressConfidential, 'yes.childDetails[1].childRes[1].child_live_with') && form.getField("SchildLive2").setText(get(props.addressConfidential, 'yes.childDetails[1].childRes[1].child_live_with', "").concat(`, ` + get(props.addressConfidential, 'yes.childDetails[1].childRes[1].child_address', "")));
  //     has(props.addressConfidential, 'yes.childDetails[1].childRes[1].relationship') && form.getField("Srelation2").setText(get(props.addressConfidential, 'yes.childDetails[1].childRes[1].relationship', ""));
  //     has(props.addressConfidential, 'yes.childDetails[1].childRes[1].child_address') && form.getField("Sstate1").setText(get(props.addressConfidential, 'yes.childDetails[1].childRes[1].child_address', ""));



  //     has(props.addressConfidential, 'yes.childDetails[1].childRes[2].date_from') && (get(props.addressConfidential, 'yes.childDetails[1].childRes[2].date_from') == '1947-01-01') ? form.getField("Sfrom2").setText("") : form.getField("Sfrom2").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[1].childRes[2].date_from', "")));
  //     has(props.addressConfidential, 'yes.childDetails[1].childRes[2].date_to') && (get(props.addressConfidential, 'yes.childDetails[1].childRes[2].date_to') == '1947-01-01') ? form.getField("Sto2").setText("") : form.getField("Sto2").setText(parseDate(get(props.addressConfidential, 'yes.childDetails[1].childRes[2].date_to', "")));
  //     has(props.addressConfidential, 'yes.childDetails[1].childRes[2].child_live_with') && form.getField("SchildLive3").setText(get(props.addressConfidential, 'yes.childDetails[1].childRes[2].child_live_with', "").concat(`, ` + get(props.addressConfidential, 'yes.childDetails[1].childRes[2].child_address', "")));
  //     has(props.addressConfidential, 'yes.childDetails[1].childRes[2].relationship') && form.getField("Srelation3").setText(get(props.addressConfidential, 'yes.childDetails[1].childRes[2].relationship', ""));
  //     has(props.addressConfidential, 'yes.childDetails[1].childRes[2].child_address') && form.getField("Sstate2").setText(get(props.addressConfidential, 'yes.childDetails[1].childRes[2].child_address', ""));
  //   }

  //   // form.flatten();
  //   const pdfBytes = await pdfDoc.save();
  //   const pdfDataUrl = URL.createObjectURL(
  //     new Blob([pdfBytes], { type: "application/pdf" })
  //   );
  //   window.open(pdfDataUrl, "_blank");
  // }

  async function myFunctionFL105() {
    const existingPdfBytes = await fetch(`${serverApi}/FL-105`, {
      headers: {
        Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
      },
    }).then((res) => res.arrayBuffer());

    var bytes = new Uint8Array(existingPdfBytes);
    const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
    const form = pdfDoc.getForm();

    const headerNameField = form.getTextField("name");
    headerNameField.setFontSize(7);
    const headerFirstNameFiled = form.getField("f_name")
    headerFirstNameFiled.setFontSize(7);
    const headerAddressFiled = form.getField("s_address")
    headerAddressFiled.setFontSize(7);
    const headerCityFiled = form.getField("city")
    headerCityFiled.setFontSize(7);
    const headerStateFiled = form.getField("state")
    headerStateFiled.setFontSize(7);
    const headerZipCodeFiled = form.getField("zipcode")
    headerZipCodeFiled.setFontSize(7);
    const headerTelephoneFiled = form.getField("telephone")
    headerTelephoneFiled.setFontSize(7);
    const headerEmailFiled = form.getField("email")
    headerEmailFiled.setFontSize(7);
    if(props.petitionerCheck == "0"){;
      !isUndefined(petitionerDetails) && headerNameField.setText(`${petitionerDetails.firstName} ${petitionerDetails.lastName}`);
      !isUndefined(petitionerDetails) && headerFirstNameFiled.setText(`${petitionerDetails.firstName}`);
      !isUndefined(petitionerDetails) && headerAddressFiled.setText(`${petitionerDetails.streetAddress}`);
      !isUndefined(petitionerDetails) && headerCityFiled.setText(`${petitionerDetails.city}`);
      !isUndefined(petitionerDetails) && headerStateFiled.setText(`${petState[0].state_name}`);
      !isUndefined(petitionerDetails) && headerZipCodeFiled.setText(`${petitionerDetails.zip}`);
      !isUndefined(petitionerDetails) && headerTelephoneFiled.setText(petitionerDetails.telephone);
      !isUndefined(petitionerDetails) && headerEmailFiled.setText(petitionerDetails.email);
    } else {
      !isUndefined(respondentDetails) && headerNameField.setText(`${respondentDetails.firstName} ${respondentDetails.lastName}`);
      !isUndefined(respondentDetails) && headerFirstNameFiled.setText(`${respondentDetails.firstName}`);
      !isUndefined(respondentDetails) && headerAddressFiled.setText(`${respondentDetails.streetAddress}`);
      !isUndefined(respondentDetails) && headerCityFiled.setText(`${respondentDetails.city}`);
      !isUndefined(respondentDetails) && headerStateFiled.setText(`${petState[0].state_name}`);
      !isUndefined(respondentDetails) && headerZipCodeFiled.setText(`${respondentDetails.zip}`);
      !isUndefined(respondentDetails) && headerTelephoneFiled.setText(respondentDetails.telephone);
      !isUndefined(respondentDetails) && headerEmailFiled.setText(respondentDetails.email);
    }

    const headerTitleField = form.getField("case_name");
    headerTitleField.setFontSize(7);
    !isUndefined(petitionerDetails) && headerTitleField.setText(`IRMO ${petitionerDetails.lastName}`);
    
    const headerCourtAddress = form.getField("court_s_address");
    headerCourtAddress.setFontSize(7);
    const headerCourtMailing = form.getField("court_m_address");
    headerCourtMailing.setFontSize(7);
    const headerCourtCity = form.getField("court_cz_address");
    headerCourtCity.setFontSize(7);
    const headerCourtBranch = form.getField("court_b_address");
    headerCourtBranch.setFontSize(7);
    // Field Need To be Set
    const headerCourtSuperior = form.getField("all_court");
    headerCourtSuperior.setFontSize(7);
    // Zain Need To change This 

    if(!isUndefined(courtDetails)){
      headerCourtAddress.setText(courtDetails.courtStreetAddress);
      headerCourtMailing.setText(courtDetails.courtMailingAddress);
      headerCourtCity.setText(`${courtDetails.city} ${courtDetails.zip}`);
      headerCourtBranch.setText(courtDetails.branchName);
      headerCourtSuperior.setText(courtDetails.county);
      form.getField("case_number").setText(courtDetails.caseNumber.toString());
      form.getField("case_number_1").setText(courtDetails.caseNumber.toString());
    }
        
    const headerPetitionerName = form.getField("petitioner");
    headerPetitionerName.setFontSize(7);
    const headerRespondentName = form.getField("respondent");
    headerRespondentName.setFontSize(7);
    !isUndefined(petitionerDetails) && headerPetitionerName.setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    !isUndefined(respondentDetails) && headerRespondentName.setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
    form.getField("checkbox_1").check();
    
    var childInfoName = [];
    var childInfoDob = [];
    var childInfoPlace = [];
    var countNumOfChild = 0;
    if (!isUndefined(props.underAge18Child.yes.childInfo) && Array.isArray(props.underAge18Child.yes.childInfo) && props.underAge18Child.yes.childInfo.length > 0) {
      countNumOfChild = props.underAge18Child.yes.childInfo.length;
      const childInfoCount = form.getField("specify_number");
      childInfoCount.setFontSize(10);
      childInfoCount.setText(countNumOfChild.toString());
      props.underAge18Child.yes.childInfo.forEach((child,index)=>{
        childInfoName[index] = form.getField(`full_name_${index+1}`);
        childInfoName[index].setFontSize(8);
        childInfoName[index].setText(`${child.first_name} ${child.last_name}`);
        childInfoDob[index] = form.getField(`dob_${index+1}`);
        childInfoDob[index].setFontSize(8);
        childInfoDob[index].setText(child.dob);
        childInfoPlace[index] = form.getField(`place_${index+1}`);
        childInfoPlace[index].setFontSize(8);
        childInfoPlace[index].setText(child.place_birth);
      })
    }
    props.moreThanChildren == 1 ? form.getField("checkbox_3").check() : form.getField("checkbox_3").uncheck();
    if (countNumOfChild > 0 && countNumOfChild < 2) {
      form.getField("checkbox_4").check();
      form.getField("checkbox_7").uncheck();
      form.getField("checkbox_8").uncheck();
      if (!isUndefined(props.addressConfidential.yes.childDetails) && Array.isArray(props.addressConfidential.yes.childDetails) && props.addressConfidential.yes.childDetails.length > 0) {
        const childDetails = props.addressConfidential.yes.childDetails[0];
        const childFromDate = form.getField("from_1");
        childFromDate.setFontSize(8);
        childFromDate.setText(childDetails.datefrom);
        const childToDate = form.getField("present");
        childToDate.setFontSize(8);
        childToDate.setText("Present");
        childDetails.child_live_cond == "1" ? form.getField("checkbox_6").check() : form.getField("checkbox_6").uncheck();
        childDetails.confidential == "1" ? form.getField("checkbox_5").check() : form.getField("checkbox_5").uncheck();
        const childRelation = form.getField("relationship_1");
        childRelation.setFontSize(8);
        childRelation.setText(childDetails.childrelation);
        if(!isUndefined(props.addressConfidential.yes.childDetails[0].childRes) && Array.isArray(props.addressConfidential.yes.childDetails[0].childRes) && props.addressConfidential.yes.childDetails[0].childRes.length > 0) {
          const childFromDate = form.getField("from_2");
          childFromDate.setFontSize(8);
          childFromDate.setText(childDetails.childRes[3].datefrom);
          const childToDate = form.getField("to_1");
          childToDate.setFontSize(8);
          childToDate.setText("Present");
          const childAddress = form.getField("residence_1");
          childAddress.setFontSize(8);
          childAddress.setText(childDetails.childRes[3].address_child);
          const childLiveWith = form.getField("person_1");
          childLiveWith.setFontSize(8);
          childLiveWith.setText(childDetails.childRes[3].child_live);
          const childRelation = form.getField("relationship_2");
          childRelation.setFontSize(8);
          childRelation.setText(childDetails.childRes[3].childrelation);
          // array Insertion
          const arrayOfChildFromDateRes = [];
          const arrayOfChildToDateRes = [];
          const arrayOfChildAddressRes = [];
          const arrayOfChildLiveWithRes = [];
          const arrayOfChildRelationRes = [];
          childDetails.childRes.slice(0, 3).forEach((childRes,index)=>{
            arrayOfChildFromDateRes[index] = form.getField(`from_${index+3}`);
            arrayOfChildFromDateRes[index].setFontSize(8);
            arrayOfChildFromDateRes[index].setText(childRes.date_from); 
            arrayOfChildToDateRes[index] = form.getField(`to_${index+2}`);
            arrayOfChildToDateRes[index].setFontSize(8);
            arrayOfChildToDateRes[index].setText(childRes.date_to); 
            arrayOfChildAddressRes[index] = form.getField(`residence_${index+2}`);
            arrayOfChildAddressRes[index].setFontSize(8);
            arrayOfChildAddressRes[index].setText(childRes.child_address); 
            arrayOfChildLiveWithRes[index] = form.getField(`person_${index+2}`);
            arrayOfChildLiveWithRes[index].setFontSize(8);
            arrayOfChildLiveWithRes[index].setText(childRes.child_live_with); 
            arrayOfChildRelationRes[index] = form.getField(`relationship_${index+3}`);
            arrayOfChildRelationRes[index].setFontSize(8);
            arrayOfChildRelationRes[index].setText(childRes.relationship); 
          })
        }
      }
    } else if(countNumOfChild > 1 && props.addressConfidential.yes.sameResidence != "" && Array.isArray(props.addressConfidential.yes.sameResidence) && ((countNumOfChild - 1) == props.addressConfidential.yes.sameResidence.length)) {
      form.getField("checkbox_4").check();
      form.getField("checkbox_7").uncheck();
      form.getField("checkbox_8").uncheck();
      if (!isUndefined(props.addressConfidential.yes.childDetails) && Array.isArray(props.addressConfidential.yes.childDetails) && props.addressConfidential.yes.childDetails.length > 0) {
        const childDetails = props.addressConfidential.yes.childDetails[0];
        const childFromDate = form.getField("from_1");
        childFromDate.setFontSize(8);
        childFromDate.setText(childDetails.datefrom);
        const childToDate = form.getField("present");
        childToDate.setFontSize(8);
        childToDate.setText("Present");
        childDetails.child_live_cond == "1" ? form.getField("checkbox_6").check() : form.getField("checkbox_6").uncheck();
        childDetails.confidential == "1" ? form.getField("checkbox_5").check() : form.getField("checkbox_5").uncheck();
        const childRelation = form.getField("relationship_1");
        childRelation.setFontSize(8);
        childRelation.setText(childDetails.childrelation);
        if(!isUndefined(props.addressConfidential.yes.childDetails[0].childRes) && Array.isArray(props.addressConfidential.yes.childDetails[0].childRes) && props.addressConfidential.yes.childDetails[0].childRes.length > 0) {
          const childFromDate = form.getField("from_2");
          childFromDate.setFontSize(8);
          childFromDate.setText(childDetails.childRes[3].datefrom);
          const childToDate = form.getField("to_1");
          childToDate.setFontSize(8);
          childToDate.setText("Present");
          const childAddress = form.getField("residence_1");
          childAddress.setFontSize(8);
          childAddress.setText(childDetails.childRes[3].address_child);
          const childLiveWith = form.getField("person_1");
          childLiveWith.setFontSize(8);
          childLiveWith.setText(childDetails.childRes[3].child_live);
          const childRelation = form.getField("relationship_2");
          childRelation.setFontSize(8);
          childRelation.setText(childDetails.childRes[3].childrelation);
          // array Insertion
          const arrayOfChildFromDateRes = [];
          const arrayOfChildToDateRes = [];
          const arrayOfChildAddressRes = [];
          const arrayOfChildLiveWithRes = [];
          const arrayOfChildRelationRes = [];
          childDetails.childRes.slice(0, 3).forEach((childRes,index)=>{
            arrayOfChildFromDateRes[index] = form.getField(`from_${index+3}`);
            arrayOfChildFromDateRes[index].setFontSize(8);
            arrayOfChildFromDateRes[index].setText(childRes.date_from); 
            arrayOfChildToDateRes[index] = form.getField(`to_${index+2}`);
            arrayOfChildToDateRes[index].setFontSize(8);
            arrayOfChildToDateRes[index].setText(childRes.date_to); 
            arrayOfChildAddressRes[index] = form.getField(`residence_${index+2}`);
            arrayOfChildAddressRes[index].setFontSize(8);
            arrayOfChildAddressRes[index].setText(childRes.child_address); 
            arrayOfChildLiveWithRes[index] = form.getField(`person_${index+2}`);
            arrayOfChildLiveWithRes[index].setFontSize(8);
            arrayOfChildLiveWithRes[index].setText(childRes.child_live_with); 
            arrayOfChildRelationRes[index] = form.getField(`relationship_${index+3}`);
            arrayOfChildRelationRes[index].setFontSize(8);
            arrayOfChildRelationRes[index].setText(childRes.relationship); 
          })
        }
      }
    } else {
      form.getField("checkbox_4").uncheck();
      form.getField("checkbox_7").check();
      form.getField("checkbox_8").check();
    }

    
    !isUndefined(props.childCustodyCase.childCustodyCaseStatus) && props.childCustodyCase.childCustodyCaseStatus == '1' ? form.getField("checkbox_111").check() : form.getField("checkbox_222").check() ;
    !isUndefined(props.domesticVoilence.domesticVoilenceStatus) && props.domesticVoilence.domesticVoilenceStatus == "1" ? form.getField("checkbox_88").check() : form.getField("checkbox_88").uncheck() ;
    !isUndefined(props.custodyRights.custodyRightsStatus) && props.custodyRights.custodyRightsStatus == '1' ? form.getField("checkbox_13").check() : form.getField("checkbox_14").check() ;

    // form.flatten();
    const pdfBytes = await pdfDoc.save();
    const pdfDataUrl = URL.createObjectURL(
      new Blob([pdfBytes], { type: "application/pdf" })
    );
    window.open(pdfDataUrl, "_blank");
  }



  async function myFunction() {
    const existingPdfBytes = await fetch(`${serverApi}/FL-120`, {
      headers: {
        Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
      },
    }).then((res) => res.arrayBuffer());
    var bytes = new Uint8Array(existingPdfBytes);
    const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
    const form = pdfDoc.getForm();


    form.getCheckBox("married").check();

    form.getCheckBox("resRequest").check();

    form.getCheckBox("resRequest1").check();


    if (props.domesticPartnership.domesticPartnershipStatus == "0") {
      form.getCheckBox("dpCalifonia").uncheck();
      form.getCheckBox("dpNcalifonia").uncheck();
      form.getCheckBox("domicileCalifornia").uncheck();
      form.getCheckBox("marriedCalifornia").uncheck();
    } else {
      if (props.domesticPartnership.domesticPartnershipStatus == "1" && props.domesticPartnership.establishedInCalifornia.establishedInCaliforniaStatus == "1") {
        form.getCheckBox("dpCalifonia").check();
        form.getCheckBox("domicileCalifornia").check();
      } else if (props.domesticPartnership.domesticPartnershipStatus == "1" && props.domesticPartnership.establishedInCalifornia.establishedInCaliforniaStatus == "0") {
        form.getCheckBox("dpNcalifonia").check();
      }
    }

    if (props.domesticPartnership.domesticPartnershipStatus == "1" && props.domesticPartnership.establishedInCalifornia.establishedInCaliforniaStatus == "0") {
      form.getCheckBox("marriedCalifornia").check();
    } else {
      form.getCheckBox("marriedCalifornia").uncheck();

    }

    if (form.getCheckBox("marriedCalifornia").isChecked()) {
      form.getField("p_live").setText(filter(props.states, state => state.state_id == props.domesticPartnership.establishedInCalifornia.californiaJurisdiction.petitionerState)[0].state_name);
      form.getField("r_live").setText(filter(props.states, state => state.state_id == props.domesticPartnership.establishedInCalifornia.californiaJurisdiction.respondentState)[0].state_name);
    } else {
      form.getField("p_live").setText("");
      form.getField("r_live").setText("");
    }

    if (props.residence == "1") {
      form.getCheckBox("respondent").check();
    } else {
      form.getCheckBox("respondent").uncheck();
    }



    props.marriedBefore.marriedBeforeStatus == "1" ? form.getCheckBox("resContends").check() : form.getCheckBox("resContends").uncheck();

    !isUndefined(respondentDetails) && form.getField("name").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
    !isUndefined(courtDetails.caseNumber) && form.getField("caseNumber").setText(courtDetails.caseNumber.toString());
    !isUndefined(respondentDetails) && form.getField("streetAddress").setText(respondentDetails.streetAddress);
    !isUndefined(respondentDetails) && form.getField("city").setText(respondentDetails.city);
    !isEmpty(resState) && form.getField("state").setText(resState[0].state_name);
    !isUndefined(respondentDetails) && form.getField("zipCode").setText(respondentDetails.zip);
    !isUndefined(respondentDetails) && form.getField("telePhone").setText(respondentDetails.telephone);
    !isUndefined(respondentDetails) && form.getField("email").setText(respondentDetails.email);

    !isUndefined(courtDetails) && form.getField("courtAddress").setText(courtDetails.courtStreetAddress);
    !isUndefined(courtDetails) && form.getField("mailAddress").setText(courtDetails.courtMailingAddress);
    !isUndefined(courtDetails) && form.getField("cityZip").setText(`${courtDetails.city}` + ` ` + `${courtDetails.zip}`);
    !isUndefined(courtDetails) && form.getField("superiorCourt").setText(courtDetails.county);
    !isUndefined(courtDetails) && form.getField("branchName").setText(courtDetails.branchName);

    !isUndefined(petitionerDetails) && form.getField("courtPetitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    !isUndefined(respondentDetails) && form.getField("courtRespondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);


    !isUndefined(petitionerDetails) && form.getField("minorChildPet").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    !isUndefined(respondentDetails) && form.getField("minorChildRes").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);


    !isEmpty(courtDetails) && form.getField("caseNumber").setText(courtDetails.caseNumber.toString());


    !isUndefined(respondentDetails) && form.getField("respondentName").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);



    let marriageYear = moment(props.dates.dateOfMarriage).format('YYYY')
    let marriageSeparateYear = moment(props.dates.dateOfSeparation).format('YYYY')

    let marriageMonths = moment(props.dates.dateOfMarriage).format('MM')
    let marriageSeparateMonths = moment(props.dates.dateOfSeparation).format('MM')

    let totalMarriageMonths = marriageMonths > marriageSeparateMonths ? marriageMonths - marriageSeparateMonths : marriageSeparateMonths - marriageMonths;

    let totalMarriageYears = marriageSeparateYear - marriageYear;


    //DOMESTIC PARTNERSHIP YEARS AND MONTHS

    let DpYear = moment(props.dates.dateOfDP).format('YYYY')
    let DpSeparateYear = moment(props.dates.dateOfDPSeparation).format('YYYY')

    let DpMonths = moment(props.dates.dateOfDP).format('MM')
    let DpSeparateMonths = moment(props.dates.dateOfDPSeparation).format('MM')

    let totalDpMonths = DpSeparateMonths > DpMonths ? DpSeparateMonths - DpMonths : DpMonths - DpSeparateMonths;;

    let totalDpYears = DpSeparateYear - DpYear;

    form.getCheckBox("dateOfMarriage").check();

    if (form.getCheckBox("dateOfMarriage").isChecked() && moment(props.dates.dateOfMarriage).isValid()) {
      form.getField("m_date").setText(parseDate(props.dates.dateOfMarriage));
      form.getField("s_date").setText(parseDate(props.dates.dateOfSeparation));
      if (!isNaN(totalMarriageYears)) {
        form.getField("dateM").setText(totalMarriageYears.toString());
      } else {
        form.getField("dateM").setText("");
      }
      if (!isNaN(totalMarriageMonths)) {
        form.getField("dateS").setText(totalMarriageMonths.toString());
      } else {
        form.getField("dateS").setText("");
      }
    } else {
      form.getField("m_date").setText("");
      form.getField("s_date").setText("");
      form.getField("dateM").setText("");
      form.getField("dateS").setText("");
    }


    props.domesticPartnership.domesticPartnershipStatus == "1" ? form.getCheckBox("dateOfDp").check() : form.getCheckBox("dateOfDp").uncheck();

    if (form.getCheckBox("dateOfDp").isChecked() && moment(props.dates.dateOfDP).isValid()) {
      form.getField("dp_reg_Date").setText(parseDate(props.dates.dateOfDP));
      form.getField("dp_sep_date").setText(parseDate(props.dates.dateOfDPSeparation));

      if (!isNaN(totalDpYears)) {
        form.getField("dp_years").setText(totalDpYears.toString());
      } else {
        form.getField("dp_years").setText("");
      }

      if (!isNaN(totalDpMonths)) {
        form.getField("dp_months").setText(totalDpMonths.toString());
      } else {
        form.getField("dp_months").setText("");
      }
    } else {
      form.getField("dp_reg_Date").setText("");
      form.getField("dp_sep_date").setText("");
      form.getField("dp_years").setText("");
      form.getField("dp_months").setText("");

    }



    props.dissolveMarriage.dissolveMarriageStatus == "1" ? form.getCheckBox("resDenies").check() : form.getCheckBox("resDenies").uncheck();

    if (props.filingOption.filingOptionStatus == "1") {
      form.getCheckBox("divorce").check();

    } else if (props.filingOption.filingOptionStatus == "2") {
      form.getCheckBox("legalSeparation").check();

    } else if (props.filingOption.filingOptionStatus == "3") {
      form.getCheckBox("nullityOfVoidable").check();
    }
    else {
      form.getCheckBox("divorce").uncheck();
      form.getCheckBox("legalSeparation").uncheck();
      form.getCheckBox("nullityOfVoidable").uncheck();
    }

    if (form.getCheckBox("divorce").isChecked()) {
      props.filingOption.divorce.divorcedTypes == "1" ? form.getCheckBox("irreconcilableDiff").check() : form.getCheckBox("permanentLegal").check();

    } else if (form.getCheckBox("legalSeparation").isChecked()) {
      props.filingOption.legalSeparation.legalSeparationTypes == "1" ? form.getCheckBox("irreconcilableDiff").check() : form.getCheckBox("permanentLegal").check();

    } else if (form.getCheckBox("nullityOfVoidable").isChecked()) {
      if (props.filingOption.nulity == "2") {
        form.getCheckBox("respondentAge").check();
      } else if (props.filingOption.nulity == "3") {
        form.getCheckBox("priorExistingMarriage").check();
      } else if (props.filingOption.nulity == "4") {
        form.getCheckBox("unsoundMind").check();
      } else if (props.filingOption.nulity == "5") {
        form.getCheckBox("fraud").check();
      } else if (props.filingOption.nulity == "6") {
        form.getCheckBox("force").check();
      } else if (props.filingOption.nulity == "7") {
        form.getCheckBox("physicalIncapacity").check();
      } else {
        form.getCheckBox("respondentAge").uncheck();
        form.getCheckBox("priorExistingMarriage").uncheck();
        form.getCheckBox("unsoundMind").uncheck();
        form.getCheckBox("fraud").uncheck();
        form.getCheckBox("force").uncheck();
        form.getCheckBox("physicalIncapacity").uncheck();

      }
    }


    props.underAge18Child.no.underAge18Status == 1 ? form.getCheckBox("MinorChild").check() : form.getCheckBox("NoMinorChild").check();

    if (!isEmpty(props.childCustody.additionalForm)) {

      if (props.childCustody.additionalForm.includes("1")) {
        form.getCheckBox("FL312").check();
      }
      if (props.childCustody.additionalForm.includes("2")) {
        form.getCheckBox("FFL312").check();
      }
      if (props.childCustody.additionalForm.includes("3")) {
        form.getCheckBox("FL341C").check();
      }
      if (props.childCustody.additionalForm.includes("4")) {
        form.getCheckBox("FL341D").check();
      }
      if (props.childCustody.additionalForm.includes("5")) {
        form.getCheckBox("FL341E").check();
      }
      if (props.childCustody.additionalForm.includes("6")) {
        form.getCheckBox("Attach6C").check();
      }
    }



    if (props.childCustody.legalCustody == "1") {
      form.getCheckBox("legalPetitioner").check();
    } else if (props.childCustody.legalCustody == "2") {
      form.getCheckBox("legalResp").check();
    } else if (props.childCustody.legalCustody == "3") {
      form.getCheckBox("legalJoint").check();
    } else if (props.childCustody.legalCustody == "4") {
      form.getCheckBox("legalOther").check();
    } else {
      form.getCheckBox("legalPetitioner").uncheck();
      form.getCheckBox("legalResp").uncheck();
      form.getCheckBox("legalJoint").uncheck();
      form.getCheckBox("legalOther").uncheck();
    }

    if (props.childCustody.physicalCustody == "1") {
      form.getCheckBox("physicalPetitioner").check();
    } else if (props.childCustody.physicalCustody == "2") {
      form.getCheckBox("physicalResp").check();
    } else if (props.childCustody.physicalCustody == "3") {
      form.getCheckBox("physicalJoint").check();
    } else if (props.childCustody.physicalCustody == "4") {
      form.getCheckBox("physicalOther").check();
    } else {
      form.getCheckBox("physicalPetitioner").uncheck();
      form.getCheckBox("physicalResp").uncheck();
      form.getCheckBox("physicalJoint").uncheck();
      form.getCheckBox("physicalOther").uncheck();
    }

    if (props.childCustody.childVisitation == "1") {
      form.getCheckBox("childPetitioner").check();
    } else if (props.childCustody.childVisitation == "2") {
      form.getCheckBox("childResp").check();
    } else if (props.childCustody.childVisitation == "3") {
      form.getCheckBox("childOther").check();
    } else {
      form.getCheckBox("childPetitioner").uncheck();
      form.getCheckBox("childResp").uncheck();
      form.getCheckBox("childOther").uncheck();
    }


    if (props.spousalSupport.spousalSupportPayable.spousalSupportPayableStatus == 1 || props.spousalSupport.spousalSupportPayable.spousalSupportPayableStatus == 2 || props.spousalSupport.spousalSupportPayable.spousalSupportPayableStatus == 3) {
      form.getCheckBox("partnerSupport").check();
    } else {
      form.getCheckBox("partnerSupport").uncheck();
    }
    if (props.spousalSupport.spousalSupportTerminate.spousalSupportTerminateStatus == 1 || props.spousalSupport.spousalSupportTerminate.spousalSupportTerminateStatus == 2 || props.spousalSupport.spousalSupportTerminate.spousalSupportTerminateStatus == 3) {
      form.getCheckBox("awardSupport").check();
    } else {
      form.getCheckBox("awardSupport").uncheck();
    }
    if (props.spousalSupport.spousalSupportReserve.spousalSupportReserveStatus == 1 || props.spousalSupport.spousalSupportReserve.spousalSupportReserveStatus == 2 || props.spousalSupport.spousalSupportReserve.spousalSupportReserveStatus == 3) {
      form.getCheckBox("issueSupport").check();
    } else {
      form.getCheckBox("issueSupport").uncheck();
    }

    //111

    if (form.getCheckBox("partnerSupport").isChecked()) {
      if (props.spousalSupport.spousalSupportPayable.spousalSupportPayableStatus == 1) {
        form.getCheckBox("partnerPet").check();
      } else if (props.spousalSupport.spousalSupportPayable.spousalSupportPayableStatus == 2) {
        form.getCheckBox("partnerResp").check();
      }
      else if (props.spousalSupport.spousalSupportPayable.spousalSupportPayableStatus == 3) {
        form.getCheckBox("partnerPet").check();
        form.getCheckBox("partnerResp").check();
      }
      else {
        form.getCheckBox("partnerPet").uncheck();
        form.getCheckBox("partnerResp").uncheck();
      }
    }

    //222

    if (form.getCheckBox("awardSupport").isChecked()) {
      if (props.spousalSupport.spousalSupportTerminate.spousalSupportTerminateStatus == 1) {
        form.getCheckBox("awardPet").check()
      } else if (props.spousalSupport.spousalSupportTerminate.spousalSupportTerminateStatus == 2) {
        form.getCheckBox("awardResp").check();
      }
      else if (props.spousalSupport.spousalSupportTerminate.spousalSupportTerminateStatus == 3) {
        form.getCheckBox("awardPet").check()
        form.getCheckBox("awardResp").check();
      }
      else {
        form.getCheckBox("awardPet").uncheck();
        form.getCheckBox("awardResp").uncheck();
      }
    }

    //3333

    if (form.getCheckBox("issueSupport").isChecked()) {
      if (props.spousalSupport.spousalSupportReserve.spousalSupportReserveStatus == 1) {
        form.getCheckBox("issuePet").check()
      } else if (props.spousalSupport.spousalSupportReserve.spousalSupportReserveStatus == 2) {
        form.getCheckBox("issueResp").check();
      }
      else if (props.spousalSupport.spousalSupportReserve.spousalSupportReserveStatus == 3) {
        form.getCheckBox("issuePet").check()
        form.getCheckBox("issueResp").check();
      }
      else {
        form.getCheckBox("issuePet").uncheck();
        form.getCheckBox("issueResp").uncheck();
      }
    }


    // if (
    //   props.filingOption.filingOptionStatus == "1" &&
    //   props.domesticPartnership.domesticPartnershipStatus == "1" &&
    //   props.respondantDissolutionOfMarriage.no.respondantDissolutionOfMarriageStatus == "1"
    // ) {
    //   form.getCheckBox("disSolutionMarriage").check();
    //   form.getCheckBox("disSolution").check();
    //   form.getCheckBox("disSolutionDp").check();
    // } else if (
    //   props.filingOption.filingOptionStatus == "1" &&
    //   props.domesticPartnership.domesticPartnershipStatus == "1" &&
    //   props.respondantDissolutionOfMarriage.no.respondantDissolutionOfMarriageStatus == "0"
    // ) {
    //   form.getCheckBox("disSolution").check();
    //   form.getCheckBox("disSolutionDp").check();
    // } else if (
    //   props.filingOption.filingOptionStatus == "1" &&
    //   props.domesticPartnership.domesticPartnershipStatus == "0" &&
    //   props.respondantDissolutionOfMarriage.no.respondantDissolutionOfMarriageStatus == "1"
    // ) {
    //   form.getCheckBox("disSolution").check();
    //   form.getCheckBox("disSolutionMarriage").check();
    // } else if (
    //   props.filingOption.filingOptionStatus == "2" &&
    //   props.domesticPartnership.domesticPartnershipStatus == "1" &&
    //   props.respondantDissolutionOfMarriage.no.respondantDissolutionOfMarriageStatus == "1"
    // ) {
    //   form.getCheckBox("legalSep").check();
    //   form.getCheckBox("legalSepMarriage").check();
    //   form.getCheckBox("legalSepDp").check();
    // } else if (
    //   props.filingOption.filingOptionStatus == "2" &&
    //   props.domesticPartnership.domesticPartnershipStatus == "1" &&
    //   props.respondantDissolutionOfMarriage.no.respondantDissolutionOfMarriageStatus == "0"
    // ) {
    //   form.getCheckBox("legalSep").check();
    //   form.getCheckBox("legalSepDp").check();
    // } else if (
    //   props.filingOption.filingOptionStatus == "2" &&
    //   props.domesticPartnership.domesticPartnershipStatus == "0" &&
    //   props.respondantDissolutionOfMarriage.no.respondantDissolutionOfMarriageStatus == "1"
    // ) {
    //   form.getCheckBox("legalSep").check();
    //   form.getCheckBox("legalSepMarriage").check();
    // } else if (
    //   props.filingOption.filingOptionStatus == "3" &&
    //   props.domesticPartnership.domesticPartnershipStatus == 1 &&
    //   props.respondantDissolutionOfMarriage.no.respondantDissolutionOfMarriageStatus == "1"
    // ) {
    //   form.getCheckBox("nullityOf").check();
    //   form.getCheckBox("nullityDp").check();
    //   form.getCheckBox("nullityMarriage").check();
    // } else if (
    //   props.filingOption.filingOptionStatus == "3" &&
    //   props.domesticPartnership.domesticPartnershipStatus == "1" &&
    //   props.respondantDissolutionOfMarriage.no.respondantDissolutionOfMarriageStatus == "0"
    // ) {
    //   form.getCheckBox("nullityOf").check();
    //   form.getCheckBox("nullityDp").check();
    // } else if (
    //   props.filingOption.filingOptionStatus == "3" &&
    //   props.domesticPartnership.domesticPartnershipStatus == "0" &&
    //   props.respondantDissolutionOfMarriage.no.respondantDissolutionOfMarriageStatus == "1"
    // ) {
    //   form.getCheckBox("nullityOf").check();
    //   form.getCheckBox("nullityMarriage").check();
    // } else {
    //   form.getCheckBox("disSolutionMarriage").uncheck();
    //   form.getCheckBox("disSolution").uncheck();
    //   form.getCheckBox("disSolutionDp").uncheck();
    //   form.getCheckBox("legalSep").uncheck();
    //   form.getCheckBox("legalSepMarriage").uncheck();
    //   form.getCheckBox("legalSepDp").uncheck();
    //   form.getCheckBox("nullityOf").uncheck();
    //   form.getCheckBox("nullityDp").uncheck();
    //   form.getCheckBox("nullityMarriage").uncheck();
    // }


    if (props.filingOption.filingOptionStatus == "1" && props.domesticPartnership.domesticPartnershipStatus == "1") {
      form.getCheckBox("disSolution").check();
      form.getCheckBox("disSolutionDp").check();
    } else if (props.filingOption.filingOptionStatus == "1" && props.domesticPartnership.domesticPartnershipStatus == "0") {
      form.getCheckBox("disSolution").check();
      form.getCheckBox("disSolutionMarriage").check();
    } else if (props.filingOption.filingOptionStatus == "2" && props.domesticPartnership.domesticPartnershipStatus == "1") {
      form.getCheckBox("legalSep").check();
      form.getCheckBox("legalSepDp").check();
    } else if (props.filingOption.filingOptionStatus == "2" && props.domesticPartnership.domesticPartnershipStatus == "0") {
      form.getCheckBox("legalSep").check();
      form.getCheckBox("legalSepMarriage").check();
    } else if (props.filingOption.filingOptionStatus == "3" && props.domesticPartnership.domesticPartnershipStatus == "1") {
      form.getCheckBox("nullityOf").check();
      form.getCheckBox("nullityDp").check();
    } else if (props.filingOption.filingOptionStatus == "3" && props.domesticPartnership.domesticPartnershipStatus == "0") {
      form.getCheckBox("nullityOf").check();
      form.getCheckBox("nullityMarriage").check();
    }


    props.underAge18Child.yes.signVDOP.isSignVDOP == 1 ? form.getCheckBox("volDeclaration").check() : form.getCheckBox("volDeclaration").uncheck();


    if (form.getCheckBox("MinorChild").isChecked()) {
      !isEmpty(props.underAge18Child.yes) && props.underAge18Child.yes.unbornChildrenStatus.isMotherPregnant == 1 ? form.getCheckBox("childNotBorn").check() : form.getCheckBox("childNotBorn").uncheck();
      props.moreThanChildren == 1 ? form.getCheckBox("contAttachment").check() : form.getCheckBox("contAttachment").uncheck()
      !isEmpty(props.underAge18Child.yes.childInfo) && props.underAge18Child.yes.childInfo.map((childDetails, index) => {
        !isEmpty(childDetails) && form.getField(`firstChild${index}`).setText(`\t` + `${childDetails.first_name}` + " " + `${childDetails.last_name}`);
        !isEmpty(childDetails) && form.getField(`firstBDate${index}`).setText(moment(`\t` + `${childDetails.dob == "1947-01-01" ? "" : childDetails.dob}`).format("MM-DD-YYYY"));
        !isEmpty(childDetails) && form.getField(`firstAge${index}`).setText(`\t` + `${childDetails.childern_age}`.toString());
      })
    }

    !isUndefined(petitionerDetails) && form.getField("seperatePetitioner").setText(petitionerDetails.firstName);
    !isUndefined(respondentDetails) && form.getField("seperateRespondent").setText(respondentDetails.firstName);
    !isUndefined(courtDetails) && form.getField("caseNum").setText(courtDetails.caseNumber.toString());


    props.separateProperty.no.separatePropertyStatus == "1" ? form.getCheckBox("sepProAsset").check() : form.getCheckBox("propertyAssets").check();
    props.communityProperty.no.communityPropertyStatus == "1" ? form.getCheckBox("communityProAssets").check() : form.getCheckBox("communityAssets").check();

    if (form.getCheckBox("communityProAssets").isChecked()) {
      props.communityProperty.yes.useLanguage == "0" ? form.getCheckBox("proDeclaration").check() : form.getCheckBox("communityfollow").check()
    } else {
      form.getCheckBox("proDeclaration").uncheck()
      form.getCheckBox("communityfollow").uncheck()
    }


    if (form.getCheckBox("communityfollow").isChecked()) {
      form.getField("communitySpecify").setText("Discovery is ongoing and I reserve the right to amend the Response at a later date and shall   exchange the Preliminary Declaration of Disclosure with Petitioner.")
    } else {
      form.getField("communitySpecify").setText("")
    }


    if (form.getCheckBox("sepProAsset").isChecked()) {
      props.separateProperty.yes.useLanguage == "0" ? form.getCheckBox("propertyDec").check() : form.getCheckBox("propertyList").check()
    } else {
      form.getCheckBox("propertyDec").uncheck()
      form.getCheckBox("propertyList").uncheck()
    }

    if (form.getCheckBox("propertyList").isChecked()) {
      form.getField("sepItem1").setText("All property received prior to marriage or after the date of separation, & its rents, profits, therefrom. Discovery is ongoing and I reserve the right to amend my Response at a later date. ")
    } else {
      form.getField("sepItem1").setText("")
    }








    props.restoreFormerLastName.yes.name_response != "" ? form.getCheckBox("ResFormerName").check() : form.getCheckBox("ResFormerName").uncheck();
    console.log(props.restoreFormerLastName.yes.name_response, "checkedtest")
    form.getCheckBox("ResFormerName").isChecked() ? form.getField("formerSpecify").setText(props.restoreFormerLastName.yes.name_response) : form.getField("formerSpecify").setText(" ");
    // form.flatten();
    const pdfBytes = await pdfDoc.save();
    const pdfDataUrl = URL.createObjectURL(
      new Blob([pdfBytes], { type: "application/pdf" })
    );
    window.open(pdfDataUrl, "_blank");
  }

  const steps = getSteps();

  function getCheckedValue(value) {
    if (FL.includes(value)) {
      let dummyArray = FL;
      remove(dummyArray, function (val) {
        return val === value;
      });
    } else {
      let dummyArray = FL;
      dummyArray.push(value);
      setFL(dummyArray);
    }
  }

  const arrayCBOne = () => {
    let cb = [];
    forEach([1, 2, 3, 4, 5, 6], (y) => {
      let z = !isEmpty(props.childCustody.additionalForm) && (props.childCustody.additionalForm).includes(`${y}`)
      z == true && cb.push(z == true ? `${y}` : "");
    });
    setFL(cb)
  }

  const handlePostFunc = () => {
    if (activeStep === 0) {
      props.putRespondantFiledPetition({
        dissolutionOfMarriageStatus: (document.getElementById("dissolutionOfMarriageStatus").value == "0" || document.getElementById("dissolutionOfMarriageStatus").value == "-1") ? (handleShow(), document.getElementById("dissolutionOfMarriageStatus").value) : document.getElementById("dissolutionOfMarriageStatus").value,
        divorce_id: window.localStorage.getItem("divorce_id"),
      });
    } else if (activeStep === 1) {
      props.postDPDetails({
        isDp: document.getElementById("inDomesticPartnerShip").value,
        userId: window.localStorage.getItem("user_id"),
        domesticPartnershipInCalifornia: document.getElementById("inDomesticPartnerShip").value == "1" ? document.getElementById("dpResideCalifornia").value : document.getElementById("inDomesticPartnerShip").value == "-1" ? "-1" : 0,
        petitionerLive: (document.getElementById("inDomesticPartnerShip").value == "1" && document.getElementById("dpResideCalifornia").value == "0") ? document.getElementById("petitionerState").value : (document.getElementById("inDomesticPartnerShip").value == "1" && document.getElementById("dpResideCalifornia").value == "-1") ? "-1" : 0,
        respondantLive: (document.getElementById("inDomesticPartnerShip").value == "1" && document.getElementById("dpResideCalifornia").value == "0") ? document.getElementById("respondantState").value : (document.getElementById("inDomesticPartnerShip").value == "1" && document.getElementById("dpResideCalifornia").value == "-1") ? "-1" : 0,
        divorce_id: window.localStorage.getItem("divorce_id"),
      });
    } else if (activeStep === 2) {
      props.putMarriedBefore({
        marriedBeforeStatus: document.getElementById("neverMarried").value,
        divorce_id: window.localStorage.getItem("divorce_id"),
      });
    } else if (activeStep === 3) {
      props.putDenyingDissolvingMarriage({
        denyingMarriageCheck: document.getElementById("denyingMarriageStatus")
          .value,
        divorce_id: window.localStorage.getItem("divorce_id"),
      });
    } else if (activeStep === 4) {
      props.isResidence({
        resideCalifornia: (document.getElementById("residence").value == "0" || document.getElementById("residence").value == "-1") ? (handleShowCaliforniaResidency(), document.getElementById("residence").value) : document.getElementById("residence").value,
        divorce_id: window.localStorage.getItem("divorce_id"),
      });
    }
    else if (activeStep === 5) {
      props.putRespondantFilingOptions({
        divorce_id: window.localStorage.getItem("divorce_id"),
        filingOptionTypes: document.getElementById("filingOptionTypes").value,
        divorceBase:
          document.getElementById("filingOptionTypes").value === "1"
            ? document.getElementById("divorcedTypes").value
            : 0,
        legalSeparationBase:
          document.getElementById("filingOptionTypes").value === "2"
            ? document.getElementById("legalSeparation").value
            : 0,
        groundNullity:
          document.getElementById("filingOptionTypes").value === "3"
            ? document.getElementById("nulity").value
            : 0,
      });
    } else if (activeStep === 6) {
      props.putDates({
        dateofMarriage: document.getElementById("dateOfMarriage").value,
        dateofSepration: document.getElementById("dateOfSeparation").value,
        dateOfDP: document.getElementById("dateOfDomesticPartnership").value,
        dateOfDPSeparation: document.getElementById("dateDomesticOfSeparation").value,
        divorce_id: window.localStorage.getItem("divorce_id"),
      });
    }

    else if (activeStep === 7) {
      props.putChildAge({
        respondentChildUnder18: (document.getElementById("childern").value === "0" || document.getElementById("childern").value === "-1") ? ((setActiveStep((prevActiveStep) => prevActiveStep === 7 && prevActiveStep + 4)), document.getElementById("childern").value) : 1,
        divorce_id: window.localStorage.getItem("divorce_id"),

      });
    }

    else if (activeStep === 8) {
      props.putAddCustody({
        legalCustody: document.getElementById("legalcustody").value,
        physicalCustody: document.getElementById("physicalCustody").value,
        childVisitation: document.getElementById("childvisitation").value,
        additionalForm: FL,
        divorce_id: window.localStorage.getItem("divorce_id"),
      });
    } else if (activeStep === 9) {
      props.putChildCustodyCase({
        divorce_id: window.localStorage.getItem("divorce_id"),
        childCustody: document.getElementById("participatedInAnyOtherCourt")
          .value,
      });
    } else if (activeStep === 10) {
      props.putDomesticViolence({
        divorce_id: window.localStorage.getItem("divorce_id"),
        domesticViolence: document.getElementById("domesticViolence").value,
      });
    } else if (activeStep === 11) {
      props.putChildCustodyRights({
        divorce_id: window.localStorage.getItem("divorce_id"),
        childCustodyRight: document.getElementById("custodyRights").value,
      });
    } else if (activeStep === 12) {
      props.putAddSppousalSupport({
        payableSs: document.getElementById("spousalSupport").value,
        courtAbilityAward: document.getElementById("terminateCourt").value,
        reserveRightsSs: document.getElementById("receiveSpousal").value,
        divorce_id: window.localStorage.getItem("divorce_id"),
      });
    } else if (activeStep === 13) {
      props.putSeparateProperty({
        divorce_id: window.localStorage.getItem("divorce_id"),
        separateProperty: document.getElementById("separateProperty").value,
        separateUseLanguage: document.getElementById("SeparateSelect").value,
      });
    } else if (activeStep === 14) {
      props.putCommunityProperty({
        divorce_id: window.localStorage.getItem("divorce_id"),
        communityProperty: document.getElementById("communityProperty").value,
        communityLanguage: document.getElementById("CommunitySelect").value,
      });
    } else if (activeStep === 15) {
      props.putFormerLastName({
        isPet: false,
        restore_name_res: document.getElementById("restoreName").value,
        userId: window.localStorage.getItem("user_id"),
        name_response: document.getElementById("restoreName").value == "0" || document.getElementById("restoreName") == "-1"
          ? ""
          : document.getElementById("updateName").value,
      });
    } else {

    }
  };

  function saveByteArray(reportName, byte) {
    var blob = new Blob([byte], { type: "application/pdf" });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
  }

  const handleNext = () => {
    handlePostFunc();
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => ((props.underAge18 === 0 || props.underAge18 == -1) && prevActiveStep === 12) ? prevActiveStep - 5 :
      prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const [isFilledPtetion, setisFilledPtetion] = useState(props.respondantDissolutionOfMarriage.no.respondantDissolutionOfMarriageStatus == "1" ? 1 : -1);
  const [isSameSex, setIsSameSex] = useState();
  const [isDomestic, setDomestic] = useState(props.domesticPartnership.domesticPartnershipStatus == "1" ? 1 : -1);
  const [isDivorceBased, setIsDivorcedBased] = useState(props.filingOption.filingOptionStatus == "1" ? 1 : -1);
  const [isSeperationBased, setIsSeperationBased] = useState(props.filingOption.filingOptionStatus == "2" ? 1 : -1);
  const [isNullityBased, setIsNullityBased] = useState(props.filingOption.filingOptionStatus == "3" ? 1 : -1);
  const [separateProperty, setseparateProperty] = useState(props.separateProperty.no.separatePropertyStatus == "1" ? 1 : 0);
  const [communityProperty, setcommunityProperty] = useState(props.communityProperty.no.communityPropertyStatus == "1" ? 1 : 0);
  const [restoreName, setRestoreName] = useState(props.restoreFormerLastName.no.restore_name_res == 1 ? 1 : 0);
  const [filingOptionState, setFilingOptionState] = useState(1);
  const [isDomesticInCalifornia, setDomesticInCalifornia] = useState(props.domesticPartnership.establishedInCalifornia.establishedInCaliforniaStatus);
  const [show, setShow] = useState(false);

  const [showCaliforniaResidency, setCaliforniaResidency] = useState(false);

  const handleShowCaliforniaResidency = () => setCaliforniaResidency(true);
  const handleCloseCaliforniaResidency = () => setCaliforniaResidency(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const [FL, setFL] = useState([]);

  const test = (value) => {
    if (value === "1") {
      setFilingOptionState(value);
      setIsDivorcedBased(true);
      setIsNullityBased(false);
      setIsSeperationBased(false);
    } else if (value === "2") {
      setFilingOptionState(value);
      setIsDivorcedBased(false);
      setIsNullityBased(false);
      setIsSeperationBased(true);
    } else {
      setFilingOptionState(value);
      setIsDivorcedBased(false);
      setIsNullityBased(true);
      setIsSeperationBased(false);
    }
  };


  const ColoredLineSimple = ({ color }) => (
    <hr
      style={{
        borderTop: "1px dashed",
        color: "black",
      }}
    />
  );

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div style={{ margin: "4%" }}>
            <FormGroup>
              <Label for="dissolutionOfMarriageStatus">
                <h5>
                  Has your spouse filed a Petition for Dissolution of Marriage
                  (FL-100)?
                </h5>
              </Label>
              <Input
                defaultValue={
                  props.respondantDissolutionOfMarriage.no.respondantDissolutionOfMarriageStatus
                }
                type="select"
                name="dissolutionOfMarriageStatus"
                id="dissolutionOfMarriageStatus"
                onChange={(e) => setisFilledPtetion(JSON.parse(e.target.value))}
              >
                <option selected value="-1"> -- select an option -- </option>
                <option value="1" selected={props.respondantDissolutionOfMarriage.no.respondantDissolutionOfMarriageStatus === "1"}>Yes</option>
                <option value="0" selected={props.respondantDissolutionOfMarriage.no.respondantDissolutionOfMarriageStatus === "0"}>No</option>
              </Input>
            </FormGroup>

          </div>
        );

      //Q3
      case 1:
        return (
          <div>
            <FormGroup>
              <Label for="inDomesticPartnerShip">
                Are you in a domestic partnership?
              </Label>
              <Input
                defaultValue={
                  props.domesticPartnership.domesticPartnershipStatus
                }
                type="select"
                name="inDomesticPartnerShip"
                id="inDomesticPartnerShip"
                onChange={(e) => setDomestic(JSON.parse(e.target.value))}
              >
                <option selected value="-1"> -- select an option --{" "}
                </option>
                <option
                  value="0"
                >
                  No
                </option>
                <option
                  value="1"
                >
                  Yes
                </option>
              </Input>
            </FormGroup>

            <Collapse isOpen={isDomestic == "1"}>
              <FormGroup>
                <Label for="dpResideCalifornia">
                  {" "}
                  Was your domestic partnership established in California?
                </Label>
                <Input
                  defaultValue={
                    props.domesticPartnership.establishedInCalifornia.establishedInCaliforniaStatus
                  }
                  type="select"
                  name="dpResideCalifornia"
                  id="dpResideCalifornia"
                  onChange={(e) => setDomesticInCalifornia(e.target.value)}
                >
                  <option selected value="-1">
                    {" "}
                    -- select an option --{" "}
                  </option>
                  <option value="0">No</option>
                  <option value="1">Yes</option>
                </Input>
              </FormGroup>

              <Collapse isOpen={isDomesticInCalifornia == "0"}>

                <FormGroup>
                  <Label for="whichJurisdiction">
                    You must be married in California and live in a
                    jurisdiction that will not recognize your marriage, and
                    filing in the county in which you married.
                  </Label>
                  <FormGroup>
                    <Label for="petitionerState">

                      What State does (Petitioner) live?
                    </Label>
                    <Input
                      defaultValue={
                        props.domesticPartnership.establishedInCalifornia.californiaJurisdiction.petitionerState
                      }
                      type="select"
                      name="petitionerState"
                      id="petitionerState"
                    >
                      <option selected value="-1">
                        -- select an option --
                      </option>

                      {!isEmpty(props.states) &&
                        props.states.map((item, i) => (
                          <option
                            name={item.state_name}
                            value={item.state_id}
                            selected={item.state_id === 6 ? true : false}
                          >
                            {item.state_name}
                          </option>
                        ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label for="respondantState">
                      What State does (Respondent) live?
                    </Label>
                    <Input
                      defaultValue={
                        props.domesticPartnership.establishedInCalifornia.californiaJurisdiction.respondentState
                      }
                      type="select"
                      name="respondantState"
                      id="respondantState"
                    >
                      <option selected value="-1">
                        -- select an option --
                      </option>
                      {!isEmpty(props.states) &&
                        props.states.map((item, i) => (
                          <option
                            name={item.state_name}
                            value={item.state_id}
                            selected={item.state_id === 6 ? true : false}
                          >
                            {item.state_name}
                          </option>
                        ))}
                    </Input>
                  </FormGroup>
                </FormGroup>
              </Collapse>
            </Collapse>
          </div>
        );
      // Q4

      case 2:
        return (
          <div>
            {/* Q4 Starts from here */}
            <FormGroup>
              <Label for="neverMarried">
                <h5>
                  Do you contend that you were never married? This is
                  uncommon.
                </h5>
              </Label>
              <Input
                defaultValue={props.marriedBefore.marriedBeforeStatus}
                name="neverMarried"
                type="select"
                id="neverMarried"
              >
                <option selected value="-1">
                  -- select an option --
                </option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </Input>
            </FormGroup>
          </div>
        );

      // Q5

      case 3:
        return (
          <div>
            {/* Q5 Starts From here */}
            <FormGroup>
              <Label for="denyingMarriageStatus">
                <h5>
                  Do you deny the grounds your spouse is requesting to
                  dissolve your marriage? This is uncommon.
                </h5>
              </Label>
              <Input
                defaultValue={props.dissolveMarriage.dissolveMarriageStatus}
                type="select"
                name="denyingMarriageStatus"
                id="denyingMarriageStatus"
              >
                <option selected value="-1"> -- select an option -- </option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </Input>
            </FormGroup>
          </div>
        );

      // Q6
      case 4:
        return (
          <div>
            {/* Q5 Starts From here */}
            <FormGroup>
              <Label for="Residence">
                <h5>
                  Have you resided in California for the last 6 months and the
                  county for the last 3 months?
                </h5>
              </Label>
              <Input
                defaultValue={props.residence}
                type="select"
                name="residence"
                id="residence"
              >
                <option selected value="-1"> -- select an option -- </option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </Input>
            </FormGroup>
          </div>
        )

      case 5:
        return (
          <div>
            <FormGroup>
              <Label for="filingOptionTypes">
                <h5>Please select your filing option</h5>
              </Label>
              <Input
                defaultValue={props.filingOption.filingOptionStatus}
                type="select"
                name="filingOptionTypes"
                id="filingOptionTypes"
                onChange={(e) => test(e.target.value)}
              >
                <option selected value="-1"> -- select an option -- </option>
                {props.fillingOption.map((item, i) => (
                  <option value={item.filing_option_id}>{item.name}</option>
                ))}
              </Input>
            </FormGroup>
            <Collapse isOpen={isDivorceBased == "1"}>
              <FormGroup>
                <Label for="divorce">
                  You can divorce based on (select one)
                </Label>
                <Input
                  defaultValue={props.filingOption.divorce.divorcedTypes}
                  type="select"
                  name="divorcedTypes"
                  id="divorcedTypes"
                >
                  <option selected value="-1">
                    -- select an option --
                  </option>
                  {props.divorceLsBasis.map((item, i) => (
                    <option value={item.divorce_ls_basis_id}>
                      {item.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Collapse>
            <Collapse isOpen={isSeperationBased == "1"}>
              <FormGroup>
                <Label for="legalSeparation">
                  You can get a legal separation based on (select one)
                </Label>
                <Input
                  defaultValue={
                    props.filingOption.legalSeparation.legalSeparationTypes
                  }
                  type="select"
                  name="legalSeparation"
                  id="legalSeparation"
                >
                  <option selected value="-1"> -- select an option -- </option>
                  {props.divorceLsBasis.map((item, i) => (
                    <option value={item.divorce_ls_basis_id}>
                      {item.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Collapse>
            <Collapse isOpen={isNullityBased == "1"}>
              <FormGroup>
                <Label for="nulity">Select one as grounds for nullity:</Label>
                <Input
                  defaultValue={props.filingOption.nulity}
                  type="select"
                  name="nulity"
                  id="nulity"
                >
                  <option selected value="-1"> -- select an option -- </option>
                  {props.nullityBasis.map((item, i) => (
                    <option value={item.nullity_basis_id}>{item.name}</option>
                  ))}
                </Input>
              </FormGroup>
            </Collapse>
          </div>
        );

      // Q7

      case 6:
        return (
          <div>
            {/* Q7 Starts from here */}
            <h5>Please Provide</h5>
            <Row form>
              <Col md={6}>
                <FormGroup>
                  <Label for="dateOfMarriage">Date Of Marriage</Label>
                  <Input
                    defaultValue={moment(props.dates.dateOfMarriage == "1947-01-01" ? "" : props.dates.dateOfMarriage).format('YYYY-MM-DD')}
                    type="date"
                    name="dateOfMarriage"
                    id="dateOfMarriage"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="dateOfSeparation">Date Of Separation</Label>
                  <Input
                    defaultValue={moment(props.dates.dateOfSeparation == "1947-01-01" ? "" : props.dates.dateOfSeparation).format('YYYY-MM-DD')}
                    type="date"
                    name="dateOfSeparation"
                    id="dateOfSeparation"
                  />
                </FormGroup>
              </Col>
            </Row>
            {/* If yes To Doemstic Parternship */}
            <Collapse isOpen={isDomestic == "1"}>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="dateOfDomesticPartnership">
                      Date Domestic Partnership Registered
                    </Label>
                    <Input
                      defaultValue={moment(props.dates.dateOfDP == "1947-01-01" ? "" : props.dates.dateOfDP).format("YYYY-MM-DD")}
                      type="date"
                      name="dateOfDomesticPartnership"
                      id="dateOfDomesticPartnership"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="dateDomesticOfSeparation">
                      Date Of Separation
                    </Label>
                    <Input
                      defaultValue={moment(props.dates.dateOfDPSeparation == "1947-01-01" ? "" : props.dates.dateOfDPSeparation).format("YYYY-MM-DD")}
                      type="date"
                      name="dateDomesticOfSeparation"
                      id="dateDomesticOfSeparation"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Collapse>
          </div>
        );


      case 7:
        return (
          <div>
            <FormGroup>
              <FormGroup>
                <Label for="childern">
                  <h5>
                    Do you and your spouse have any children under the age of
                    18?
                  </h5>
                </Label>
                <Input
                  defaultValue={props.underAge18}
                  type="select"
                  name="childern"
                  id="childern"
                >
                  <option selected value="-1">
                    {" "}
                    -- select an option --{" "}
                  </option>

                  <option value="0">No</option>
                  <option value="1">Yes</option>
                </Input>
              </FormGroup>
            </FormGroup>
          </div>
        );

      // Q10

      case 8:
        return (
          <div>
            {/* Question Number 10 Starts Here */}

            <h5>Please select the following</h5>

            <FormGroup>
              <Label for="legalcustody">Legal Custody (select one only)</Label>
              <Input
                defaultValue={props.childCustody.legalCustody}
                type="select"
                name="legalcustody"
                id="legalcustody"
              >
                <option selected value="-1"> -- select an option -- </option>
                <option value="1">Petitioner</option>
                <option value="2">Respondent</option>
                <option value="3">Joint</option>
                <option value="4">Other</option>
                <option value="5">Not Applicable</option>
              </Input>
            </FormGroup>

            <FormGroup>
              <Label for="physicalCustody">
                Physical Custody (select one only)
              </Label>
              <Input
                defaultValue={props.childCustody.physicalCustody}
                type="select"
                name="physicalCustody"
                id="physicalCustody"
              >
                <option selected value="-1"> -- select an option -- </option>
                <option value="1">Petitioner</option>
                <option value="2">Respondent</option>
                <option value="3">Joint</option>
                <option value="4">Other</option>
                <option value="5">Not Applicable</option>
              </Input>
            </FormGroup>

            <FormGroup>
              <Label for="childvisitation">
                Child visitation (not required)
              </Label>
              <Input
                defaultValue={props.childCustody.childVisitation}
                type="select"
                name="childvisitation"
                id="childvisitation"
              >
                <option selected value="-1"> -- select an option -- </option>
                <option value="1">Petitioner</option>
                <option value="2">Respondent</option>
                <option value="3">Other</option>
                <option value="4">Not Applicable</option>
              </Input>
            </FormGroup>

            <FormGroup>
              <Label for="additionalForms">
                Do you want to include any of these additional forms?{" "}
              </Label>
              <Row>
                <Col md={2}>
                  <CustomInput
                    type="checkbox"
                    id="exampleCustomCheckbox"
                    label="FL-311"
                    value="1"
                    onChange={(e) => getCheckedValue(e.target.value)}
                    defaultChecked={!isEmpty(props.childCustody.additionalForm) && size(props.childCustody.additionalForm.find(x => x === '1'))}
                  />
                </Col>

                <Col md={2}>
                  <CustomInput
                    type="checkbox"
                    id="exampleCustomCheckbox2"
                    label="FL-312"
                    value="2"
                    onChange={(e) => getCheckedValue(e.target.value)}
                    defaultChecked={!isEmpty(props.childCustody.additionalForm) && size(props.childCustody.additionalForm.find(x => x === '2'))}
                  />
                </Col>

                <Col md={2}>
                  <CustomInput
                    type="checkbox"
                    id="exampleCustomCheckbox3"
                    label="FL-341(C)"
                    value="3"
                    onChange={(e) => getCheckedValue(e.target.value)}
                    defaultChecked={!isEmpty(props.childCustody.additionalForm) && size(props.childCustody.additionalForm.find(x => x === '3'))}
                  />
                </Col>

                <Col md={2}>
                  <CustomInput
                    type="checkbox"
                    id="exampleCustomCheckbox4"
                    label="FL-341(D)"
                    value="4"
                    onChange={(e) => getCheckedValue(e.target.value)}
                    defaultChecked={!isEmpty(props.childCustody.additionalForm) && size(props.childCustody.additionalForm.find(x => x === '4'))}
                  />
                </Col>

                <Col md={2}>
                  <CustomInput
                    type="checkbox"
                    id="exampleCustomCheckbox5"
                    label="FL-341(E)"
                    value="5"
                    onChange={(e) => getCheckedValue(e.target.value)}
                    defaultChecked={!isEmpty(props.childCustody.additionalForm) && size(props.childCustody.additionalForm.find(x => x === '5'))}
                  />
                </Col>

                <Col md={2}>
                  <CustomInput
                    type="checkbox"
                    id="exampleCustomCheckbox6"
                    label="Attachment 6(c)(1)"
                    value="6"
                    onChange={(e) => getCheckedValue(e.target.value)}
                    defaultChecked={!isEmpty(props.childCustody.additionalForm) && size(props.childCustody.additionalForm.find(x => x === '6'))}
                  />
                </Col>
              </Row>
            </FormGroup>
          </div>
        );

      // 11
      case 9:
        return (
          <div>
            <FormGroup>
              <Label for="participatedInAnyOtherCourt">
                <h5>
                  Have you participated in any other court case for custody
                  of your child?
                </h5>
              </Label>
              <Input
                defaultValue={props.childCustodyCase.childCustodyCaseStatus}
                type="select"
                name="participatedInAnyOtherCourt"
                id="participatedInAnyOtherCourt"
              >
                <option selected value="-1"> -- select an option -- </option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </Input>
            </FormGroup>
          </div>
        );

      // 12

      case 10:
        return (
          <div>
            <FormGroup>
              <Label for="domesticViolence">
                <h5>
                  Are there any domestic violence restraining orders
                  currently in effect?
                </h5>
              </Label>
              <Input
                defaultValue={props.domesticVoilence.domesticVoilenceStatus}
                type="select"
                name="domesticViolence"
                id="domesticViolence"
              >
                <option selected value="-1"> -- select an option -- </option>
                <option value="0">No</option>
                <option value="1">Yes</option>

              </Input>
            </FormGroup>
          </div>
        );

      // 13

      case 11:
        return (
          <div>
            <FormGroup>
              <Label for="custodyRights">
                <h5>
                  Does anyone other than you and your spouse have custody
                  rights to your children?
                </h5>
              </Label>
              <Input
                defaultValue={props.custodyRights.custodyRightsStatus}
                type="select"
                name="custodyRights"
                id="custodyRights"
              >
                <option selected value="-1"> -- select an option -- </option>
                <option value="0">No</option>
                <option value="1">Yes</option>

              </Input>
            </FormGroup>
          </div>
        );

      // 14

      case 12:
        return (
          <div>

            <FormGroup>
              <Label for="spousalSupport">Spousal support payable to</Label>
              <Input
                defaultValue={
                  props.spousalSupport.spousalSupportPayable.spousalSupportPayableStatus
                }
                type="select"
                name="spousalSupport"
                id="spousalSupport"
              >
                <option selected value="-1"> -- select an option -- </option>true
                <option value="1">Petitioner </option>
                <option value="2">Respondent</option>
                <option value="4">Not Applicable</option>
                <option value="3">Both(Petitioner & Respondent)</option>
              </Input>
            </FormGroup>

            <FormGroup>
              <Label for="terminateCourt">
                Terminate (end) court’s ability to award support to
              </Label>
              <Input
                defaultValue={
                  props.spousalSupport.spousalSupportTerminate.spousalSupportTerminateStatus
                }
                type="select"
                name="terminateCourt"
                id="terminateCourt"
              >
                <option selected value="-1"> -- select an option -- </option>
                <option value="1">Petitioner</option>
                <option value="2">Respondent</option>
                <option value="4">Not Applicable</option>
                <option value="3">Both(Petitioner & Respondent)</option>
              </Input>
            </FormGroup>

            <FormGroup>
              <Label for="receiveSpousal">
                Reserve the right to receive spousal support from
              </Label>
              <Input
                defaultValue={
                  props.spousalSupport.spousalSupportReserve.spousalSupportReserveStatus
                }
                type="select"
                name="receiveSpousal"
                id="receiveSpousal"
              >
                <option selected value="-1"> -- select an option -- </option>
                <option value="1">Petitioner </option>
                <option value="2">Respondent</option>
                <option value="4">Not Applicable</option>
                <option value="3">Both(Petitioner & Respondent)</option>
              </Input>
            </FormGroup>
          </div>
        );

      // 15

      case 13:
        return (
          <div>
            <FormGroup>
              <Label for="separateProperty?">
                Do you have any separate property?
              </Label>
              <Input
                defaultValue={props.separateProperty.no.separatePropertyStatus}
                type="select"
                name="separateProperty"
                id="separateProperty"
                onChange={(e) =>
                  setseparateProperty(JSON.parse(e.target.value))
                }
              >
                <option selected value="-1"> -- select an option -- </option>
                <option value="1" selected={props.separateProperty.no.separatePropertyStatus == "1"}>Yes </option>
                <option value="0" selected={props.separateProperty.no.separatePropertyStatus == "0"}>No</option>
              </Input>
            </FormGroup>
            {/* Open if Seprate Property is yes */}
            <Collapse isOpen={separateProperty == "1"}>
              <FormGroup>
                <Label for="SeparateSelect">
                  Please select how you would like to disclose your separate property:
                </Label>
                <Input
                  defaultValue={props.separateProperty.yes.useLanguage}
                  type="select"
                  id="SeparateSelect"
                >
                  <option selected value="-1">
                    {" "}
                    -- select an option --{" "}
                  </option>
                  <option value="0">I will include an FL-160 with my Response</option>
                  <option value="1">I want to include general language in my form</option>
                </Input>
              </FormGroup>
            </Collapse>
          </div>
        );

      //16

      case 14:
        return (
          <div>
            <FormGroup>
              <Label for="communityProperty?">
                Do you have any community property?
              </Label>
              <Input
                defaultValue={
                  props.communityProperty.no.communityPropertyStatus
                }
                type="select"
                name="communityProperty"
                id="communityProperty"
                onChange={(e) =>
                  setcommunityProperty(JSON.parse(e.target.value))
                }
              >
                <option selected value="-1"> -- select an option -- </option>
                <option value="1" selected={props.communityProperty.no.communityPropertyStatus == "1"} >Yes </option>
                <option value="0" selected={props.communityProperty.no.communityPropertyStatus == "0"}>No</option>

              </Input>
            </FormGroup>
            {/* Open if Comunity Property is yes */}
            <Collapse isOpen={communityProperty == "1"}>
              <FormGroup>
                <Label for="CommunitySelect">
                  Please select how you would like to disclose your community property:
                </Label>
                <Input
                  defaultValue={props.communityProperty.yes.useLanguage}
                  type="select"
                  id="CommunitySelect"
                >
                  <option selected value="-1">
                    {" "}
                    -- select an option --{" "}
                  </option>
                  <option value="0">I will include an FL-160 with my Response</option>
                  <option value="1">I want to include general language in my form</option>
                </Input>
              </FormGroup>
            </Collapse>
          </div>
        );

      //17
      case 15:
        return (
          <div>
            <FormGroup>
              <Label for="restoreName">
                <h5>Do you want to restore your former last name?</h5>
              </Label>
              <Input
                defaultValue={
                  props.restoreFormerLastName.no.restore_name_res
                }
                type="select"
                name="restoreName"
                id="restoreName"
                onChange={(e) => setRestoreName(JSON.parse(e.target.value))}
              >
                <option selected value="-1"> -- select an option -- </option>
                <option value="0" selected={props.restoreFormerLastName.no.restore_name_res == "0"}>No</option>
                <option value="1" selected={props.restoreFormerLastName.no.restore_name_res == "1"}>Yes</option>
              </Input>
            </FormGroup>

            <Collapse isOpen={restoreName == 1}>
              <FormGroup>
                <Label for="updateName">
                  Write in the exact way you want your last name to appear
                </Label>
                <Input
                  defaultValue={props.restoreFormerLastName.yes.name_response}
                  type="text"
                  name="updateName"
                  id="updateName"
                />
              </FormGroup>
            </Collapse>
          </div>
        );

      default:
        return "Unknown step";
    }
  }

  return (
    <div className={classes.root}>

      {props.isFetchingGetAllFormData ?
        <div style={{ marginLeft: "42%", marginTop: "18%" }}>
          <Loader
            type="Puff"
            color="#00BFFF"
            height={120}
            width={120}
          />
        </div>
        :
        <div>

          <Stepper activeStep={activeStep} orientation="vertical" style={{
            fontStyle: "normal",
            fontFamily: "sans-serif",
            backgroundColor: "white",
            textAlign: "justify",
            textJustify: "inter-word",
            padding: "20px 70px"
          }}>
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  <Typography>{getStepContent(index)}</Typography>
                  <div className={classes.actionsContainer}>
                    <div>
                      <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={classes.button}
                      >
                        Back
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNext}
                        className={classes.button}
                      >
                        {activeStep === steps.length - 1 ? "Finish" : "Next"}
                      </Button>
                    </div>
                  </div>
                </StepContent>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length && (
            <Paper square elevation={0} className={classes.resetContainer}>
              <Typography>All steps completed - you&apos;re finished</Typography>
              <div>
                <Button style={{ backgroundColor: "red", color: "white" }} onClick={handleReset} className={classes.button}>
                  Reset
                </Button>
                <Button style={{ backgroundColor: "#3f51b5", color: "white" }} onClick={handleBack} className={classes.button}>
                  Back
                </Button>
              </div>
            </Paper>

          )}

          <div style={{ display: "flex", float: "right" }}>

            {(props.underAge18 == "1") &&
              <>
                <Button
                  style={{ marginRight: "1px" }}
                  variant="contained"
                  color="primary"
                  onClick={myFunctionFL105}
                >
                  Print FL 105
                </Button>

                <Button
                  style={{ marginRight: "1px" }}
                  variant="contained"
                  color="primary"
                  onClick={myFunctionFL105A}
                >
                  Print FL 105(a)
                </Button>
              </>}
            <Button
              style={{ float: "right" }}
              variant="contained"
              color="primary"
              onClick={myFunction}
            >
              Print FL 120
            </Button>

          </div>
          <Modal isOpen={showCaliforniaResidency} style={{ marginTop: "300px", marginLeft: "46%" }}>

            <ModalBody style={{ backgroundColor: "yellow" }}>
              <b>Warning</b> You must be living in California for 6 months and your county for 3 months to file for divorce. This doesn't apply to legal separation. Consider changing your response.
            </ModalBody>
            <Button
              style={{ width: "100%", color: "white", backgroundColor: "Blue" }}
              onClick={handleCloseCaliforniaResidency}
            >
              Ok
            </Button>
          </Modal>

          <Modal isOpen={show} style={{ marginTop: "300px", marginLeft: "46%" }}>

            <ModalBody style={{ backgroundColor: "yellow" }}>
              <b>Warning</b> The Petition must be filed before the Response or at the same. Make sure that this will be true.
            </ModalBody>
            <Button
              style={{ width: "100%", color: "white", backgroundColor: "Blue" }}
              onClick={handleClose}
            >
              Ok
            </Button>
          </Modal>
        </div>}
    </div>
  );
}

const mapStateToProps = (state, ownProps) => ({
  states: state.ProfileInformationReducer.states,
  dissolutionOfMarriage: state.responsePacketReducer.dissolutionOfMarriage,
  nullityBasis: state.responsePacketReducer.nullityBasis,
  divorceLsBasis: state.responsePacketReducer.divorceLsBasis,
  petitioner: state.ProfileInformationReducer.petitionerDetails,
  respondent: state.ProfileInformationReducer.respondentDetails,
  court: state.ProfileInformationReducer.court,
  domesticPartnership: state.responsePacketReducer.domesticPartnership,
  marriedBefore: state.responsePacketReducer.marriedBefore,
  dissolveMarriage: state.responsePacketReducer.dissolveMarriage,
  filingOption: state.responsePacketReducer.filingOption,
  fillingOption: state.responsePacketReducer.fillingOption,
  dates: state.responsePacketReducer.dates,
  childCustody: state.responsePacketReducer.childCustody,
  childCustodyCase: state.responsePacketReducer.childCustodyCase,
  domesticVoilence: state.responsePacketReducer.domesticVoilence,
  custodyRights: state.responsePacketReducer.custodyRights,
  spousalSupport: state.responsePacketReducer.spousalSupport,
  separateProperty: state.responsePacketReducer.separateProperty,
  communityProperty: state.responsePacketReducer.communityProperty,
  restoreFormerLastName: state.responsePacketReducer.restoreFormerLastName,
  underAge18: state.responsePacketReducer.underAge18,
  respondantDissolutionOfMarriage: state.responsePacketReducer.respondantDissolutionOfMarriage,
  isFetchingGetAllFormData: state.responsePacketReducer.isFetchingGetAllFormData,
  residence: state.responsePacketReducer.residence,
  petitionerCheck: state.ProfileInformationReducer.petitionerCheck,
  underAge18Child: state.ChildInformationReducer.underAge18,
  moreThanChildren: state.ChildInformationReducer.moreThanChildren,
  addressConfidential: state.ChildInformationReducer.addressConfidential,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getProfileFormData: (data) => dispatch(getProfileFormData(data)),
    getRespondentFormData: () => dispatch(getRespondentFormData()),
    putRespondantFiledPetition: (data) =>
      dispatch(putRespondantFiledPetition(data)),
    getAddForms: () => dispatch(getAddForms()),
    putAddSppousalSupport: (data) => dispatch(putAddSppousalSupport(data)),
    putAddCustody: (data) => dispatch(putAddCustody(data)),
    putFormerLastName: (data) => dispatch(putFormerLastName(data)),
    putChildResidence: (data) => dispatch(putChildResidence(data)),
    getCustodyTypes: () => dispatch(getCustodyTypes()),
    postDPDetails: (data) => dispatch(postDPDetails(data)),
    getStates: () => dispatch(getStates()),
    getFillingOption: () => dispatch(getFillingOption()),
    getDivorceLS: () => dispatch(getDivorceLS()),
    getNullity: () => dispatch(getNullity()),
    getDivorce: (data) => dispatch(getDivorce(data)),
    putDates: (data) => dispatch(putDates(data)),
    getCustodySubtypes: () => dispatch(getCustodySubtypes()),
    putUpdateData: (data) => dispatch(putUpdateData(data)),
    putChildAge: (data) => dispatch(putChildAge(data)),
    putDenyingDissolvingMarriage: (data) =>
      dispatch(putDenyingDissolvingMarriage(data)),
    putMarriedBefore: (data) => dispatch(putMarriedBefore(data)),
    putRespondantFilingOptions: (data) =>
      dispatch(putRespondantFilingOptions(data)),
    putChildCustodyCase: (data) => dispatch(putChildCustodyCase(data)),
    putDomesticViolence: (data) => dispatch(putDomesticViolence(data)),
    putChildCustodyRights: (data) => dispatch(putChildCustodyRights(data)),
    putSeparateProperty: (data) => dispatch(putSeparateProperty(data)),
    putCommunityProperty: (data) => dispatch(putCommunityProperty(data)),
    isResidence: (data) => dispatch(isResidence(data)),
    childGetAllData: (data) => dispatch(childGetAllData(data)),

  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VerticalLinearStepper);
